export const closingCross = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11 2.73085L9.26927 1L6.00009 4.26931L2.73076 1L1 2.73077L4.26934 6.00012L1 9.26958L2.73081 11.0005L6.00017 7.73096L9.2692 11L11 9.26919L7.73092 6.00013L11 2.73085Z" />
  </svg>
);

export const smallerClosingCross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
  >
    <path d="M8.99997 2.5L7.49997 1L4.99998 3.5L2.49999 1L1 2.5L3.49999 5L1 7.5L2.49999 9L4.99998 6.5L7.49997 9L8.99997 7.5L6.49998 5L8.99997 2.5Z" />
  </svg>
);

export const crossCircle = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#F83959" />
    <path
      d="M12 5.5L10.5 4L7.99998 6.5L5.49999 4L4 5.5L6.49999 8L4 10.5L5.49999 12L7.99998 9.5L10.5 12L12 10.5L9.49998 8L12 5.5Z"
      fill="white"
    />
  </svg>
);

export const leagueIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.51226 4.64423C2.2292 4.64423 1.99807 4.87438 2.00001 5.15851C2.03725 10.6066 3.84759 12.9306 6.81043 13.4443C6.36481 12.9514 6.20286 12.6364 5.94591 12.0625C4.21807 11.224 3.03597 8.89405 3.03597 5.68269H4.87109C4.8342 5.26391 4.84737 5.04272 4.87099 4.64595L2.51226 4.64423Z"
      fill="currentColor"
    />
    <path
      d="M21.4877 4.64423C21.7708 4.64423 22.0019 4.87438 22 5.15851C21.9628 10.6066 20.1524 12.9306 17.1896 13.4443C17.6352 12.9514 17.7971 12.6364 18.0541 12.0625C19.7819 11.224 20.964 8.89405 20.964 5.68269H19.1289C19.1658 5.26391 19.1526 5.04272 19.129 4.64595L21.4877 4.64423Z"
      fill="currentColor"
    />
    <path
      d="M9.39878 19.875H10.3623C11.2334 18.2476 11.2623 17.3397 11.3105 15.7212C10.0173 15.2574 9.0025 14.508 8.21973 13.5577C7.92502 13.1999 7.66321 12.8137 7.43179 12.4035C6.37001 10.5214 5.94837 8.13531 5.92763 5.68269C5.92471 5.33745 5.92974 4.99089 5.94204 4.64423C5.96153 4.09478 5.99931 3.54508 6.05271 3H17.9473C18.0007 3.54508 18.0385 4.09478 18.058 4.64423C18.0703 4.99089 18.0753 5.33745 18.0724 5.68269C18.0516 8.13531 17.63 10.5214 16.5682 12.4035C16.3368 12.8137 16.075 13.1999 15.7803 13.5577C14.9975 14.508 13.9827 15.2574 12.6895 15.7212C12.7377 17.3397 12.7666 18.2476 13.6377 19.875H14.6012C15.1639 19.875 15.6201 20.3329 15.6201 20.8977C15.6201 20.9542 15.5745 21 15.5182 21H8.4818C8.42553 21 8.37991 20.9542 8.37991 20.8977C8.37991 20.3329 8.83607 19.875 9.39878 19.875Z"
      fill="currentColor"
    />
  </svg>
);

export const clubsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20 5.32759C19.9617 12.4473 19.7211 16.8119 12 21C4.27891 16.8119 4.03829 12.4473 4 5.32759H4.72158C5.79283 5.32759 6.66124 4.45917 6.66124 3.38793C6.66124 3.38793 9.909 3 12 3C14.091 3 17.3388 3.38793 17.3388 3.38793C17.3388 4.45917 18.2072 5.32759 19.2784 5.32759H20Z"
      fill="currentColor"
    />
  </svg>
);

export const warningIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6064 14.6668H1.39365C0.31619 14.6668 -0.352491 13.5479 0.195645 12.6621L6.802 1.98628C7.3406 1.1159 8.6594 1.1159 9.198 1.98628L15.8044 12.6621C16.3525 13.5479 15.6838 14.6668 14.6064 14.6668ZM8.12141 3.56688C8.49447 3.56688 8.79492 3.87299 8.78796 4.24598L8.68294 9.87366C8.67616 10.2369 8.37973 10.5279 8.01639 10.5279H7.94106C7.57772 10.5279 7.28129 10.2369 7.27451 9.87366L7.16949 4.24598C7.16253 3.87299 7.46298 3.56688 7.83604 3.56688H8.12141ZM7.27173 13.152C7.46826 13.3365 7.70475 13.4287 7.98122 13.4287C8.16109 13.4287 8.32598 13.3858 8.47587 13.2999C8.62576 13.214 8.74567 13.0995 8.83561 12.9564C8.92888 12.8101 8.97717 12.6494 8.9805 12.4745C8.97717 12.2137 8.87725 11.991 8.68072 11.8065C8.48419 11.6189 8.25103 11.525 7.98122 11.525C7.70475 11.525 7.46826 11.6189 7.27173 11.8065C7.07521 11.991 6.97861 12.2137 6.98194 12.4745C6.97861 12.7385 7.07521 12.9643 7.27173 13.152Z"
      fill="#F7FF05"
    />
  </svg>
);

export const todoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 12"
    fill="none"
  >
    <circle cx="6" cy="6" r="6" fill="white" fillOpacity="0.1" />
    <circle cx="6" cy="6" r="5.5" stroke="white" strokeOpacity="0.1" />
  </svg>
);

export const checkMarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.27273 5.27279L2.25 6.29554L4.86364 8.90925L9.75 4.02276L8.72727 3L4.86364 6.86374L3.27273 5.27279Z"
      fill="#00E46B"
    />
  </svg>
);

export const checkMark = (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.570068 5.41176L2.30076 3.71388L5.1578 6.57092L11.7305 0L13.4357 1.7053L5.15664 10L0.570068 5.41176Z"
      fill="white"
    />
  </svg>
);

export const flagIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1 4.95755C1 4.42967 1.42763 4.00159 1.9555 4.00102C2.48417 4.00046 2.91304 4.42887 2.91304 4.95755V20.6279H1V4.95755Z"
      fill="currentColor"
    />
    <path
      d="M22.0435 18.2182C16.7826 19.1747 14 18.6667 10.5 17.504C8.37143 16.7969 6.20265 16.5198 4.29196 16.4111V5.14412C6.1969 5.4102 8.36049 5.95412 10.5 6.99841C14.0217 8.71738 16 9.00405 22.5 8.00405C21.9421 11.7756 22 14.0022 22.0435 18.2182Z"
      fill="currentColor"
    />
  </svg>
);

export const fbIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3346 9.99935C18.3346 5.39701 14.6036 1.66602 10.0013 1.66602C5.39896 1.66602 1.66797 5.39701 1.66797 9.99935C1.66797 14.1587 4.71536 17.6063 8.69922 18.2314V12.4082H6.58333V9.99935H8.69922V8.16341C8.69922 6.07487 9.94336 4.92122 11.8469 4.92122C12.7586 4.92122 13.7122 5.08398 13.7122 5.08398V7.13477H12.6615C11.6262 7.13477 11.3034 7.77715 11.3034 8.4362V9.99935H13.6146L13.2451 12.4082H11.3034V18.2314C15.2872 17.6063 18.3346 14.1588 18.3346 9.99935Z"
      fill="white"
    />
  </svg>
);

export const copyIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5884_4244)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.60005 0H13.6C14.4837 0 15.2 0.716344 15.2 1.6V11.2C15.2 12.0837 14.4837 12.8 13.6 12.8H12V14.4C12 15.2837 11.2837 16 10.4 16H2.40005C1.51639 16 0.800049 15.2837 0.800049 14.4V4.8C0.800049 3.91634 1.51639 3.2 2.40005 3.2H4.00005V1.6C4.00005 0.716344 4.71639 0 5.60005 0ZM13.6 1.6H5.60005V3.2H10.4C11.2837 3.2 12 3.91634 12 4.8V11.2H13.6V1.6Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_5884_4244">
        <rect width="16" height="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const ytIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.9974 18.3327C14.5998 18.3327 18.3307 14.6017 18.3307 9.99935C18.3307 5.39698 14.5998 1.66602 9.9974 1.66602C5.39502 1.66602 1.66406 5.39698 1.66406 9.99935C1.66406 14.6017 5.39502 18.3327 9.9974 18.3327ZM11.8942 10.0007L8.80487 11.7864V8.21494L11.8942 10.0007ZM15.8525 8.2566C15.8168 7.78041 15.7632 7.40541 15.6858 7.12565C15.537 6.58994 15.1918 6.2447 14.6561 6.09589C14.043 5.92922 12.4894 5.83398 9.99535 5.83398L9.04892 5.8697C8.39416 5.8697 7.68583 5.88756 6.91202 5.92922C6.1263 5.96494 5.6144 6.01851 5.33464 6.09589C4.79892 6.2447 4.45368 6.58994 4.30487 7.12565C4.13821 7.73875 4.04297 8.69708 4.04297 10.0007L4.07868 10.5007C4.07868 10.8578 4.09654 11.2685 4.13821 11.7447C4.17392 12.2209 4.22749 12.5959 4.30487 12.8757C4.45368 13.4114 4.79892 13.7566 5.33464 13.9054C5.94773 14.0721 7.5013 14.1673 9.99535 14.1673L10.9418 14.1316C11.5965 14.1316 12.3049 14.1137 13.0787 14.0721C13.8644 14.0364 14.3763 13.9828 14.6561 13.9054C15.1918 13.7566 15.537 13.4114 15.6858 12.8757C15.8525 12.2626 15.9477 11.3042 15.9477 10.0007L15.912 9.50065C15.912 9.14351 15.8942 8.73279 15.8525 8.2566Z"
      fill="white"
    />
  </svg>
);

export const instagramIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327ZM10.0018 4.16602C8.41761 4.16602 8.21875 4.17296 7.59657 4.20125C6.97555 4.22972 6.55164 4.32801 6.18076 4.47227C5.79704 4.62125 5.4716 4.82057 5.14739 5.14491C4.82288 5.46918 4.62355 5.79462 4.4741 6.17817C4.32944 6.54917 4.23103 6.97325 4.20309 7.59397C4.17526 8.21622 4.16797 8.41513 4.16797 9.99941C4.16797 11.5837 4.17497 11.7819 4.2032 12.4041C4.23179 13.0251 4.33008 13.449 4.47422 13.8199C4.62332 14.2036 4.82264 14.529 5.14698 14.8533C5.47114 15.1778 5.79658 15.3776 6.18 15.5265C6.55118 15.6708 6.97514 15.7691 7.59604 15.7976C8.21829 15.8259 8.41697 15.8328 10.0011 15.8328C11.5855 15.8328 11.7837 15.8259 12.4059 15.7976C13.0269 15.7691 13.4513 15.6708 13.8225 15.5265C14.206 15.3776 14.531 15.1778 14.8551 14.8533C15.1796 14.529 15.3789 14.2036 15.5284 13.8201C15.6718 13.449 15.7702 13.025 15.7994 12.4042C15.8273 11.782 15.8346 11.5837 15.8346 9.99941C15.8346 8.41513 15.8273 8.21633 15.7994 7.59409C15.7702 6.97307 15.6718 6.54922 15.5284 6.17834C15.3789 5.79462 15.1796 5.46918 14.8551 5.14491C14.5307 4.82046 14.2061 4.62113 13.8221 4.47232C13.4503 4.32801 13.0261 4.22966 12.4051 4.20125C11.7829 4.17296 11.5848 4.16602 10 4.16602H10.0018ZM12.359 5.25078C11.744 5.22284 11.5594 5.21724 10.0018 5.21724L9.80743 5.21719H9.80718H9.80692H9.80668H9.80644C9.68886 5.21713 9.57986 5.21709 9.47852 5.21724V5.21578C8.39136 5.21701 8.18282 5.2243 7.64469 5.24862C7.07594 5.27476 6.76713 5.36955 6.5615 5.44976C6.28926 5.55569 6.09489 5.6821 5.89067 5.88627C5.68644 6.09043 5.55986 6.28486 5.4541 6.5571C5.37424 6.76272 5.27922 7.07142 5.2532 7.64017C5.22526 8.25512 5.21966 8.43882 5.21966 9.99661C5.21966 11.5544 5.22526 11.7391 5.2532 12.354C5.2791 12.9228 5.37424 13.2315 5.4541 13.4369C5.56009 13.7092 5.68644 13.9032 5.89061 14.1074C6.09478 14.3115 6.28926 14.4379 6.56144 14.5436C6.76724 14.6235 7.07594 14.7185 7.64469 14.7448C8.25959 14.7727 8.44421 14.7788 10.0018 14.7788C11.5594 14.7788 11.7441 14.7727 12.359 14.7448C12.9278 14.7187 13.2367 14.624 13.4421 14.5437C13.7145 14.438 13.9083 14.3116 14.1125 14.1075C14.3166 13.9034 14.4433 13.7096 14.549 13.4373C14.6288 13.2319 14.7239 12.9232 14.7499 12.3545C14.7778 11.7396 14.7839 11.5549 14.7839 9.99807C14.7839 8.44127 14.7778 8.25658 14.7499 7.64163C14.724 7.07288 14.6288 6.76418 14.549 6.55885C14.443 6.28661 14.3166 6.09218 14.1125 5.88802C13.9084 5.68379 13.7143 5.55738 13.4421 5.45168C13.2365 5.37182 12.9278 5.2768 12.359 5.25078ZM10.0018 7.0037C8.34749 7.0037 7.00618 8.34502 7.00618 9.99941C7.00618 11.6538 8.34749 12.9945 10.0018 12.9945C11.6562 12.9945 12.9971 11.6538 12.9971 9.99941C12.9971 8.34507 11.6562 7.0037 10.0018 7.0037ZM11.9463 9.99941C11.9463 8.92543 11.0757 8.05492 10.0018 8.05492C8.92791 8.05492 8.0574 8.92543 8.0574 9.99941C8.0574 11.0733 8.92797 11.9439 10.0018 11.9439C11.0757 11.9439 11.9463 11.0733 11.9463 9.99941ZM12.4157 6.88557C12.4157 6.49906 12.7292 6.18581 13.1157 6.18581C13.5021 6.18581 13.8157 6.49912 13.8157 6.88557C13.8157 7.27203 13.5021 7.58557 13.1157 7.58557C12.7292 7.58557 12.4157 7.27203 12.4157 6.88557Z"
      fill="white"
    />
  </svg>
);

export const xIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327ZM14.7747 4.99805H13.1133L10.3748 8.13507L8.01001 4.99882H4.58203L8.67626 10.3667L4.79483 14.8161H6.45775L9.45239 11.3843L12.0725 14.8161H15.4154L11.1455 9.1565L14.7747 4.99805ZM13.4499 13.8195H12.5291L6.51965 5.94287H7.50703L13.4499 13.8195Z"
      fill="white"
    />
  </svg>
);

export const twitchIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3307 9.9974C18.3307 14.5998 14.5998 18.3307 9.9974 18.3307C5.39502 18.3307 1.66406 14.5998 1.66406 9.9974C1.66406 5.39502 5.39502 1.66406 9.9974 1.66406C14.5998 1.66406 18.3307 5.39502 18.3307 9.9974ZM4.81914 6.24729L6.90237 4.16406H14.8189V9.9974L11.0681 13.7475H9.40268L7.31945 15.8307V13.7475H4.81914V6.24729Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9855 9.58104L12.3193 11.2472H10.6525L9.19414 12.7055V11.2472H7.31945V4.9975H13.9855V9.58104ZM11.8999 6.45505H12.7333V8.95391H11.8999V6.45505ZM9.60809 6.45505H10.4415V8.95391H9.60809V6.45505Z"
      fill="white"
    />
  </svg>
);

export const pastAndPresentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.20935 21H16.7029H17.7964C18.0726 21 18.2964 20.7761 18.2964 20.5V19.1423C18.3065 16.4437 15.4322 14.2535 14.1706 13.0609C13.8186 12.7284 13.6329 12.4255 13.6329 11.9854C13.6329 11.5453 13.8186 11.252 14.1711 10.9099C15.4226 9.69723 18.2969 7.40989 18.2969 4.6036V3.5C18.2969 3.22386 18.073 3 17.7969 3H16.7033H7.20893H6.19336C5.91722 3 5.69336 3.22386 5.69336 3.5V4.51557C5.69336 7.32187 8.56765 9.69723 9.82917 10.9099C10.1813 11.252 10.3669 11.5453 10.3669 11.9854C10.3669 12.4255 10.1813 12.7284 9.82875 13.0609C8.56765 14.254 5.69336 16.4441 5.69336 19.1423V20.5C5.69336 20.7761 5.91722 21 6.19336 21H7.20935ZM8.06914 18.8003C7.60983 19.1423 7.75626 19.6609 8.22557 19.6609L15.7738 19.6601C16.2331 19.6601 16.3896 19.1419 15.9303 18.7999L12.5766 16.3064C12.469 16.2184 12.4102 16.16 12.4102 16.0132V11.3108C12.4102 10.7827 12.5182 10.5186 12.8895 10.2058C13.4565 9.73644 14.5027 8.99346 14.9816 8.3189C15.1773 8.04524 15.1577 7.82039 14.9132 7.82039H9.07618C8.83172 7.82039 8.81211 8.04524 9.00777 8.3189C9.48709 8.99346 10.5429 9.73644 11.1003 10.2058C11.4716 10.5186 11.5792 10.7827 11.5792 11.3108V16.0136C11.5792 16.1604 11.5208 16.2192 11.4132 16.3069L8.06914 18.8003Z"
      fill="currentColor"
    />
  </svg>
);

export const rightArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8608 11.1956C16.4191 10.7967 16.4191 9.96692 15.8608 9.5681L4.58124 1.51129C3.91937 1.03853 3 1.51165 3 2.32502L3 18.4386C3 19.252 3.91937 19.7251 4.58124 19.2524L15.8608 11.1956Z"
      fill="white"
      fillOpacity="0.3"
    />
  </svg>
);

export const noIncreaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 10 11"
    fill="none"
  >
    <g clipPath="url(#clip0_6197_29342)">
      <rect x="0.5" y="8.26367" width="9" height="2" rx="0.5" fill="#1ab25c" />
    </g>
    <defs>
      <clipPath id="clip0_6197_29342">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0 0.763672)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const partialIncreaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 10 11"
    fill="none"
  >
    <g clipPath="url(#clip0_6197_29349)">
      <rect x="0.5" y="1.26367" width="9" height="2" rx="0.5" fill="#1ab25c" />
      <path
        d="M5.40687 3.83328C5.20746 3.55411 4.79254 3.55411 4.59313 3.83329L0.564728 9.47305C0.328346 9.80399 0.564908 10.2637 0.971594 10.2637H9.0284C9.43509 10.2637 9.67165 9.80399 9.43527 9.47305L5.40687 3.83328Z"
        fill="#1ab25c"
      />
    </g>
    <defs>
      <clipPath id="clip0_6197_29349">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0 0.763672)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const fullIncreaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 10 11"
    fill="none"
  >
    <g clipPath="url(#clip0_6197_29335)">
      <path
        d="M5.40687 3.83328C5.20746 3.55411 4.79254 3.55411 4.59313 3.83329L0.564728 9.47305C0.328346 9.80399 0.564908 10.2637 0.971594 10.2637H9.0284C9.43509 10.2637 9.67165 9.80399 9.43527 9.47305L5.40687 3.83328Z"
        fill="#1ab25c"
      />
    </g>
    <defs>
      <clipPath id="clip0_6197_29335">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0 0.763672)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const rarityIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.41861 4H4.78605L1 7.75L5.8093 8.65L8.41861 4Z"
      fill="currentColor"
    />
    <path
      d="M5.8093 9.85L1.4093 9.05L9.69767 18.05L5.8093 9.85Z"
      fill="currentColor"
    />
    <path
      d="M15.5814 4H19.214L23 7.75L18.1907 8.65L15.5814 4Z"
      fill="currentColor"
    />
    <path
      d="M18.1907 9.85L22.5907 9.05L14.3023 18.05L18.1907 9.85Z"
      fill="currentColor"
    />
    <path
      d="M7.1907 8.75L9.8 4H14.2L16.8093 8.75H7.1907Z"
      fill="currentColor"
    />
    <path d="M12 20L7.13953 9.95H16.8605L12 20Z" fill="currentColor" />
  </svg>
);
export const metalIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1 6.47727H7.39316V10.9091C4.53164 10.1737 1.87749 8.31818 1 6.47727Z"
      fill="currentColor"
    />
    <path
      d="M8.77208 6V11.1136H17.2336C18.323 9.79735 19.529 9.14337 21.2265 8.90487C22.1988 8.76827 23 7.99952 23 7.01768V6H8.77208Z"
      fill="currentColor"
    />
    <path
      d="M6.20228 15.6136H6.57655C8.4362 15.6136 10.0373 14.3009 10.4017 12.4773H16.1054C16.5852 14.3242 18.2524 15.6136 20.1607 15.6136H20.4929V18H17.4217C15.185 15.6598 11.4475 15.6598 9.21083 18H6.20228V15.6136Z"
      fill="currentColor"
    />
  </svg>
);

export const groupIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.89603 12.6268C7.28781 13.7932 6.42464 15.2204 6.33031 19.6127H17.6096C17.4909 15.6145 16.8862 13.9069 14.0439 12.6268C14.0439 12.6268 15.3423 10.7752 15.1355 9.49766C14.8687 7.85 13.6745 6.62434 12.0058 6.58687C10.2954 6.54846 8.99041 7.80649 8.73171 9.49766C8.53456 10.7865 9.89603 12.6268 9.89603 12.6268Z"
      fill="currentColor"
    />
    <path
      d="M8.65894 12.3679C8.65894 12.3679 7.68957 10.7358 7.93125 9.16626C8.09711 8.08906 8.69043 7.15055 9.51867 6.50702C9.1348 5.06703 8.00423 4.03519 6.47528 4.00086C4.76486 3.96245 3.45991 5.22047 3.20121 6.91165C3.00405 8.2005 4.36553 10.0407 4.36553 10.0407C1.75731 11.2072 0.894133 12.6344 0.799805 17.0267H5.6438C5.90755 14.6389 6.59176 13.4776 8.65894 12.3679Z"
      fill="currentColor"
    />
    <path
      d="M15.3403 12.3683C15.3403 12.3683 16.3097 10.7361 16.068 9.16649C15.9022 8.08925 15.3088 7.1507 14.4805 6.50714C14.8644 5.06708 15.995 4.03519 17.5241 4.00086C19.2346 3.96245 20.5396 5.22053 20.7983 6.91178C20.9955 8.20069 19.6339 10.041 19.6339 10.041C22.2423 11.2076 23.1055 12.6348 23.1998 17.0273H18.3556C18.0918 14.6394 17.4076 13.478 15.3403 12.3683Z"
      fill="currentColor"
    />
  </svg>
);
export const budgetIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.57395 20.9891C3.80121 20.7667 0 16.8267 0 11.999C0 7.16308 3.8141 3.21799 8.59821 3.00781C7.6 3.58804 6.9 4.149 5.84268 5.39305C3.3805 6.57198 1.68 9.0869 1.68 11.999C1.68 14.9095 3.37868 17.4233 5.83872 18.6031C6.75787 19.6883 7.33254 20.2173 8.57395 20.9891Z"
      fill="#F1F1F1"
    />
    <path
      d="M13.2104 9.72314H12.2294C12.2204 9.72314 12.2122 9.72795 12.2078 9.73572L10.0939 13.4897C10.0852 13.505 10.0857 13.5238 10.095 13.5387L10.6198 14.3783C10.6243 14.3855 10.6322 14.3899 10.6407 14.3899H13.257C13.266 14.3899 13.2742 14.3851 13.2786 14.3773L15.3774 10.672C15.3842 10.6601 15.3835 10.6453 15.3758 10.634L14.8302 9.83674C14.8152 9.81473 14.7822 9.81617 14.7692 9.83941L12.7168 13.484C12.7062 13.5029 12.6862 13.5146 12.6645 13.5146H11.1964C11.1504 13.5146 11.1215 13.4649 11.1443 13.4249L13.2319 9.76001C13.2413 9.74356 13.2294 9.72314 13.2104 9.72314Z"
      fill="#F1F1F1"
    />
    <path
      d="M16.1568 14.357C16.1658 14.357 16.174 14.3522 16.1784 14.3444L17.7468 11.5592H16.7253L15.1705 14.3202C15.1612 14.3367 15.1731 14.357 15.192 14.357H16.1568Z"
      fill="#F1F1F1"
    />
    <path
      d="M15.6706 10.6525L17.2467 10.6332L17.7468 11.5592L18.2753 10.6206L19.362 10.6073L19.8392 9.7599C19.8484 9.74346 19.8365 9.72314 19.8176 9.72314H16.2084C16.1994 9.72314 16.1912 9.72795 16.1868 9.73572L15.6706 10.6525Z"
      fill="#F1F1F1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 21C19.9706 21 24 16.9706 24 12C24 7.02944 19.9706 3 15 3C10.0294 3 6 7.02944 6 12C6 16.9706 10.0294 21 15 21ZM15 19.32C19.0427 19.32 22.32 16.0427 22.32 12C22.32 7.95728 19.0427 4.68 15 4.68C10.9573 4.68 7.68 7.95728 7.68 12C7.68 16.0427 10.9573 19.32 15 19.32Z"
      fill="#F1F1F1"
    />
  </svg>
);

export const filterIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 3.5V5.71739L9.81818 11.6304L9.81818 16.0652L14.1818 20.5L14.1818 11.6304L20 5.71739L20 3.5H4Z"
      fill="currentColor"
    />
  </svg>
);

export const bothIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.43347 19.3581C4.39711 19.3581 1.125 16.1999 1.125 12.3041C1.125 8.40821 4.39711 5.25 8.43347 5.25C9.40545 5.25 10.3331 5.43314 11.1815 5.76562C10.0432 6.55772 9.50127 7.05268 8.83386 8.08903C8.70199 8.07751 8.56844 8.07162 8.43347 8.07162C6.01165 8.07162 4.04839 9.96655 4.04839 12.3041C4.04839 14.6416 6.01165 16.5365 8.43347 16.5365C8.61858 16.5365 8.80101 16.5254 8.98009 16.5039C9.19313 16.4784 9.40143 16.438 9.60386 16.3841C10.5824 16.1231 11.4238 15.543 12 14.767C12.5152 14.0732 12.8185 13.2228 12.8185 12.3041C12.8185 11.6354 12.6579 11.003 12.3718 10.4407C13.247 9.44327 13.7889 9.1498 14.8036 8.84357C15.401 9.86595 15.7419 11.0466 15.7419 12.3041C15.7419 13.8243 15.2437 15.2323 14.3961 16.3841C13.7687 17.2368 12.9498 17.9491 12 18.4626C11.7983 18.5716 11.5907 18.6717 11.3777 18.7623C10.477 19.1454 9.48096 19.3581 8.43347 19.3581Z"
      fill="currentColor"
    />
    <path
      d="M22.875 12.3041C22.875 16.1999 19.6029 19.3581 15.5665 19.3581C14.6756 19.3581 13.7531 19.1074 12.9636 18.8257C14.2025 17.9606 14.7532 17.2951 15.235 16.5365C15.2993 16.5392 15.5016 16.5365 15.5665 16.5365C17.9883 16.5365 19.9516 14.6416 19.9516 12.3041C19.9516 9.96655 17.9883 8.07162 15.5665 8.07162C15.1612 8.07162 14.7687 8.1247 14.3961 8.22405C13.4176 8.48499 12.5762 9.06512 12 9.84108C11.9106 9.96151 11.8275 10.0867 11.7513 10.2161C11.3886 10.8322 11.1815 11.5448 11.1815 12.3041C11.1815 12.994 11.3525 13.6453 11.6559 14.2208C10.7078 15.1781 10.1827 15.6158 9.24683 15.8494C8.61818 14.8077 8.25806 13.5965 8.25806 12.3041C8.25806 10.9368 8.66107 9.66042 9.35869 8.57951C9.43677 8.45853 9.51855 8.33999 9.60386 8.22405C10.2313 7.37135 11.0502 6.65905 12 6.14552C13.0549 5.57516 14.2714 5.25 15.5665 5.25C19.6029 5.25 22.875 8.40821 22.875 12.3041Z"
      fill="currentColor"
    />
  </svg>
);

export const marketIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8895 6.50442V11.2832H7.96787V14.7876L2.25 8.89381L7.96787 3V6.50442H14.8895Z"
      fill="currentColor"
    />
    <path
      d="M9.47257 12.7168V17.4956H16.3942V21L22.1121 15.1062L16.3942 9.21239V12.7168H9.47257Z"
      fill="currentColor"
    />
  </svg>
);

export const clubIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.95522 7.07006C6.79277 6.74081 6.98873 6.41697 7.1306 5.58256C8.99697 5.34078 10.0451 5.23334 12 5.25208C13.9549 5.23334 15.003 5.34077 16.8694 5.58254C17.0113 6.41688 17.2072 6.74069 18.0448 7.06991C17.1707 13.9173 16.022 17.0339 12 19.4593L11.9605 19.4294C8.01205 17.0096 6.85936 13.853 5.95522 7.07006Z"
      fill="currentColor"
    />
    <path
      d="M6.96269 15.66C5.79257 13.2792 5.29587 11.8173 4.94776 8.88522L1.58955 9.05046C1.42776 9.57539 1.35563 9.74149 0.75 10.0419C1.1091 14.2432 2.0426 16.3797 4.61194 18.3054C6.1554 17.3659 6.64719 16.4837 6.96269 15.66Z"
      fill="currentColor"
    />
    <path
      d="M17.0373 15.6591C18.2074 13.2785 18.7041 11.8167 19.0522 8.88491L22.4104 9.05013C22.5722 9.57502 22.6444 9.7411 23.25 10.0415C22.8302 14.2261 22.0186 16.3258 19.3881 18.3043C18.0311 17.5677 17.5483 16.7062 17.0373 15.6591Z"
      fill="currentColor"
    />
  </svg>
);
export const success = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM10.1417 14.5958L8 16.6969L13.6758 22.3748L23.921 12.1103L21.8109 10L13.6772 18.1314L10.1417 14.5958Z"
      fill="white"
    />
  </svg>
);

export const market = (active) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.8158 10.8407V18.8053H13.2798V24.646L3.75 14.823L13.2798 5V10.8407H24.8158Z"
      fill={active ? "white" : "url(#paint0_linear_3525_6894)"}
    />
    <path
      d="M15.7876 21.1947V29.1593H27.3237V35L36.8534 25.177L27.3237 15.354V21.1947H15.7876Z"
      fill={active ? "white" : "url(#paint1_linear_3525_6894)"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_3525_6894"
        x1="20.3017"
        y1="5"
        x2="20.3017"
        y2="35"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#494848" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3525_6894"
        x1="20.3017"
        y1="5"
        x2="20.3017"
        y2="35"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#494848" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
    </defs>
  </svg>
);
export const both = (active) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3058 32.2635C7.57852 32.2635 2.125 26.9998 2.125 20.5068C2.125 14.0137 7.57852 8.75 14.3058 8.75C15.9258 8.75 17.4719 9.05523 18.8858 9.60936C16.9887 10.9295 16.0855 11.7545 14.9731 13.4817C14.7533 13.4625 14.5307 13.4527 14.3058 13.4527C10.2694 13.4527 6.99731 16.6109 6.99731 20.5068C6.99731 24.4026 10.2694 27.5608 14.3058 27.5608C14.6143 27.5608 14.9183 27.5424 15.2168 27.5065C15.5719 27.4639 15.9191 27.3967 16.2564 27.3068C17.8874 26.8719 19.2896 25.905 20.25 24.6117C21.1087 23.4553 21.6142 22.038 21.6142 20.5068C21.6142 19.3923 21.3465 18.3383 20.8697 17.4012C22.3283 15.7388 23.2315 15.2497 24.9226 14.7393C25.9184 16.4433 26.4866 18.411 26.4866 20.5068C26.4866 23.0405 25.6561 25.3871 24.2436 27.3068C23.1978 28.7279 21.833 29.9151 20.25 30.771C19.9138 30.9527 19.5678 31.1196 19.2128 31.2705C17.7116 31.909 16.0516 32.2635 14.3058 32.2635Z"
      fill={active ? "white" : "url(#paint0_linear_3525_6893)"}
    />
    <path
      d="M38.375 20.5068C38.375 26.9998 32.9215 32.2635 26.1942 32.2635C24.7094 32.2635 23.1718 31.8457 21.856 31.3762C23.9209 29.9343 24.8386 28.8252 25.6416 27.5608C25.7488 27.5653 26.0859 27.5608 26.1942 27.5608C30.2306 27.5608 33.5027 24.4026 33.5027 20.5068C33.5027 16.6109 30.2306 13.4527 26.1942 13.4527C25.5187 13.4527 24.8645 13.5412 24.2436 13.7067C22.6126 14.1416 21.2104 15.1085 20.25 16.4018C20.1009 16.6025 19.9625 16.8111 19.8356 17.0268C19.231 18.0536 18.8858 19.2413 18.8858 20.5068C18.8858 21.6566 19.1708 22.7422 19.6764 23.7014C18.0963 25.2969 17.2212 26.0264 15.6614 26.4157C14.6136 24.6795 14.0134 22.6608 14.0134 20.5068C14.0134 18.228 14.6851 16.1007 15.8478 14.2992C15.978 14.0975 16.1142 13.9 16.2564 13.7067C17.3022 12.2856 18.667 11.0984 20.25 10.2425C22.0082 9.29194 24.0356 8.75 26.1942 8.75C32.9215 8.75 38.375 14.0137 38.375 20.5068Z"
      fill={active ? "white" : "url(#paint1_linear_3525_6893)"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_3525_6893"
        x1="20.25"
        y1="8.75"
        x2="20.25"
        y2="32.2635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#484747" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3525_6893"
        x1="20.25"
        y1="8.75"
        x2="20.25"
        y2="32.2635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#484747" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
    </defs>
  </svg>
);
export const club = (active) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6754 11.7834C12.0713 11.2347 12.3979 10.695 12.6343 9.30427C15.7449 8.90129 17.4919 8.72224 20.75 8.75347C24.0081 8.72224 25.7551 8.90128 28.8657 9.30423C29.1021 10.6948 29.4287 11.2345 30.8246 11.7832C29.3678 23.1954 27.4534 28.3898 20.75 32.4322L20.6841 32.3823C14.1034 28.3493 12.1823 23.0884 10.6754 11.7834Z"
      fill={active ? "white" : "url(#paint0_linear_3525_6892)"}
    />
    <path
      d="M12.3545 26.1C10.4043 22.1319 9.57645 19.6955 8.99627 14.8087L3.39925 15.0841C3.1296 15.959 3.00939 16.2358 2 16.7365C2.59851 23.7387 4.15434 27.2995 8.43657 30.509C11.009 28.9432 11.8287 27.4729 12.3545 26.1Z"
      fill={active ? "white" : "url(#paint1_linear_3525_6892)"}
    />
    <path
      d="M29.1455 26.0986C31.0957 22.1308 31.9235 19.6946 32.5037 14.8082L38.1007 15.0836C38.3704 15.9584 38.4906 16.2352 39.5 16.7358C38.8004 23.7102 37.4477 27.2096 33.0634 30.5072C30.8019 29.2795 29.9972 27.8437 29.1455 26.0986Z"
      fill={active ? "white" : "url(#paint2_linear_3525_6892)"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_3525_6892"
        x1="20.75"
        y1="8.75"
        x2="20.75"
        y2="32.4342"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#484747" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3525_6892"
        x1="20.75"
        y1="8.75"
        x2="20.75"
        y2="32.4342"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#484747" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3525_6892"
        x1="20.75"
        y1="8.75"
        x2="20.75"
        y2="32.4342"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#484747" />
        <stop offset="1" stopColor="#636363" />
      </linearGradient>
    </defs>
  </svg>
);

export const warning = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM18.1538 7.38462L17.6154 18.5012C17.6154 18.5012 17.6154 19.0571 16 19.0571C14.3846 19.0571 14.3846 18.5012 14.3846 18.5012L13.8462 7.38462H18.1538ZM17.6154 24.0596V21.8362C17.6154 21.8362 17.6154 21.2804 16 21.2804C14.3846 21.2804 14.3846 21.8362 14.3846 21.8362V24.0596C14.3846 24.0596 14.3846 24.6154 16 24.6154C17.6154 24.6154 17.6154 24.0596 17.6154 24.0596Z"
      fill="white"
    />
  </svg>
);

export const error = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM22.4616 11.7753L20.2249 9.53846L16.0001 13.7634L11.7751 9.53846L9.53846 11.7751L13.7634 16.0001L9.53846 20.2253L11.7752 22.4621L16.0002 18.2369L20.2248 22.4615L22.4615 20.2248L18.2369 16.0002L22.4616 11.7753Z"
      fill="white"
    />
  </svg>
);

export const InfoIcon = ({
  innerFill = "transparent",
  outerFill = "currentColor",
  width = "20",
  height = "20",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 9.375V15C11.25 15.6904 10.6904 16.25 10 16.25C9.30964 16.25 8.75 15.6904 8.75 15V9.375C8.75 8.68464 9.30964 8.125 10 8.125C10.6904 8.125 11.25 8.68464 11.25 9.375Z"
      fill={innerFill}
    />
    <path
      d="M11.25 5C11.25 5.69036 10.6904 6.25 10 6.25C9.30964 6.25 8.75 5.69036 8.75 5C8.75 4.30964 9.30964 3.75 10 3.75C10.6904 3.75 11.25 4.30964 11.25 5Z"
      fill={innerFill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 6.25C10.6904 6.25 11.25 5.69036 11.25 5C11.25 4.30964 10.6904 3.75 10 3.75C9.30964 3.75 8.75 4.30964 8.75 5C8.75 5.69036 9.30964 6.25 10 6.25ZM11.25 15V9.375C11.25 8.68464 10.6904 8.125 10 8.125C9.30964 8.125 8.75 8.68464 8.75 9.375V15C8.75 15.6904 9.30964 16.25 10 16.25C10.6904 16.25 11.25 15.6904 11.25 15Z"
      fill={outerFill}
    />
  </svg>
);

export const smallInfo = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2010_12280)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6ZM5.39423 9.23077V5.06203C5.39423 5.06203 5.39423 4.8536 6 4.8536C6.60577 4.8536 6.60577 5.06203 6.60577 5.06203V9.23077C6.60577 9.23077 6.60577 9.43269 6 9.43269C5.39423 9.43269 5.39423 9.23077 5.39423 9.23077ZM5.39423 2.97767V3.81141C5.39423 3.81141 5.39423 4.01985 6 4.01985C6.60577 4.01985 6.60577 3.81141 6.60577 3.81141V2.97767C6.60577 2.97767 6.60577 2.76923 6 2.76923C5.39423 2.76923 5.39423 2.97767 5.39423 2.97767Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2010_12280">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const plusIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      fill="currentColor"
      d="M21 13.6364V10.3636H13.6364L13.6362 3H10.3635V10.3636H3V13.6364H10.3635V21H13.6362L13.6364 13.6364H21Z"
    />
  </svg>
);

export const playstation = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74693 15.2411V17.7908C9.74693 17.7908 5.54377 19.3237 5.14817 19.472C4.75257 19.6204 4.45588 19.8182 4.50534 20.016C4.5893 20.3518 5.17741 20.4612 5.93936 20.461C6.70131 20.4609 7.00145 20.3872 7.67007 20.1643C8.4118 19.9171 9.74693 19.4001 9.74693 19.4001V21.6973C9.74693 21.6973 8.03515 21.9963 6.92834 21.9939C5.5246 21.991 4.72641 21.8533 3.36801 21.4995C2.85966 21.367 2.08233 21.1039 2.08233 21.1039C2.08233 21.1039 0.5 20.6105 0.5 19.5709C0.5 18.6809 1.73615 18.1234 3.46687 17.4941C6.18653 16.5051 9.74693 15.2411 9.74693 15.2411Z"
      fill="#0097D8"
    />
    <path
      d="M15.8291 19.8676V17.1974C15.8291 17.1974 18.4005 16.3569 20.774 16.3568C21.9789 16.3567 22.6649 16.4362 23.8399 16.7029C24.5073 16.8544 25.5211 17.1974 25.5211 17.1974C25.5211 17.1974 27.5486 17.8402 27.4991 18.8292C27.4497 19.8182 25.5211 20.5599 25.5211 20.5599L15.8291 24.0708V21.4995L22.6531 19.0765C22.6531 19.0765 23.5926 18.7303 23.5926 18.4336C23.5926 18.1369 22.9498 17.9391 22.1586 17.9391C21.3674 17.9391 20.774 18.1369 20.774 18.1369L15.8291 19.8676Z"
      fill="#0097D8"
    />
    <path
      d="M14.9885 24.3675L10.5875 22.9335V3.5C18.1038 5.42851 21.6641 6.1208 21.6641 11.4613C21.6641 14.181 20.5762 15.4426 18.895 15.615C18.0989 15.6967 17.5059 15.4433 16.7192 15.1205V8.19766C16.7192 7.50537 16.2247 6.96143 15.6808 6.91198C15.2357 6.87153 14.9885 7.40648 14.9885 7.90097V24.3675Z"
      fill="#0097D8"
    />
  </svg>
);

export const xbox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.91606 4.77199C9.00256 4.56336 11.7446 3.5 14.182 3.5C17.0626 3.5 19.2594 4.89863 19.5479 5.091C19.5567 5.09686 19.5507 5.10955 19.5402 5.10845C19.308 5.08396 19.1276 5.08449 18.8628 5.12302C17.6573 5.29835 15.8151 6.01664 15.4997 6.18132C15.1843 6.346 14.3549 6.8987 14.0751 6.8987C13.5867 6.8987 13.0881 6.37971 12.0756 5.95233C10.5898 5.32515 8.78887 4.90428 8.91606 4.77199Z"
      fill="#76BA1F"
    />
    <path
      d="M5.78705 20.2186C5.89527 20.3091 5.65239 19.6744 5.68021 19.3689C6.02618 15.5683 11.1038 9.63083 11.5923 9.08643C11.5923 9.08643 8.43272 6.04726 7.37954 6.01338C6.97252 6.00029 6.31619 6.60357 5.64968 7.48376C3.82187 10.1653 3.53067 11.4547 3.50771 13.6095C3.37543 16.4689 4.97809 19.5419 5.78705 20.2186Z"
      fill="#76BA1F"
    />
    <path
      d="M13.9938 11.381C14.8994 11.9661 15.6727 12.6072 17.2805 14.22C18.8882 15.8329 21.6764 18.7686 21.7883 20.1524C21.8718 21.1853 20.7469 21.7787 20.2976 22.1469C19.4529 22.8388 16.736 24.154 13.7953 24.1057C10.9869 24.0596 8.75834 22.7857 7.81715 22.1418C7.23708 21.7449 6.45074 21.1497 6.33653 20.5137C6.15715 19.5148 9.44011 15.4712 10.7884 14.2353C11.7653 13.3399 13.6071 11.6558 13.9938 11.381Z"
      fill="#76BA1F"
    />
    <path
      d="M22.3782 20.2593C22.3782 20.2593 22.3992 19.549 22.3782 19.2468C22.1037 15.2987 17.0668 9.73261 16.573 9.09155C18.3155 7.41113 19.2586 6.65882 20.8417 5.87096C21.6305 6.62905 22.1277 7.06928 22.48 7.58556C23.8997 9.66648 24.4874 10.5818 24.4998 13.6808C24.5153 17.5373 23.5486 18.5447 22.3782 20.2593Z"
      fill="#76BA1F"
    />
  </svg>
);

export const pc = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 22.9825C9.02944 22.9825 5 18.953 5 13.9825C5 12.4964 5.36015 11.0945 5.99792 9.85928C7.43917 6.53484 11.5001 2.85555 13.6498 1.92712C13.9201 1.81038 14.0997 2.09234 13.9313 2.33388C13.3246 3.20428 12.9499 3.92365 12.7727 4.88147C12.7554 4.97499 12.8357 5.05658 12.9301 5.04539C13.281 5.00383 13.638 4.98246 14 4.98246C18.9706 4.98246 23 9.0119 23 13.9825C23 15.4992 22.6248 16.9284 21.9621 18.1821C20.3735 21.2442 18.0949 23.9591 14.4062 26.0412C14.1729 26.1729 13.9323 25.8895 14.0808 25.6666C14.5498 24.9624 14.9537 24.1465 15.1271 23.0785C15.1409 22.9935 15.0683 22.9201 14.9826 22.9294C14.6599 22.9645 14.332 22.9825 14 22.9825ZM14 17.5104C15.9484 17.5104 17.5279 15.9309 17.5279 13.9825C17.5279 12.034 15.9484 10.4545 14 10.4545C12.0516 10.4545 10.4721 12.034 10.4721 13.9825C10.4721 15.9309 12.0516 17.5104 14 17.5104Z"
      fill="#F15A23"
    />
  </svg>
);

export const radioButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
    />
  </svg>
);

export const chemistryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
      fill="#1A1A1A"
    />
    <path
      d="M1.42969 11.4293L5.35826 7.50077L9.28745 11.4287L5.35904 15.3587L1.42969 11.4293Z"
      fill="#00C2FF"
    />
    <path
      d="M6.07256 6.78648L10.0011 2.85791L13.9297 6.78648L10.0011 10.7151L6.07256 6.78648Z"
      fill="#00C2FF"
    />
    <path
      d="M10.7154 11.4293L14.644 7.50077L18.5727 11.4293L14.644 15.3579L10.7154 11.4293Z"
      fill="#00C2FF"
    />
  </svg>
);

export const filledRadioButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
    />
    <circle cx="10" cy="10" r="6" />
  </svg>
);

export const cross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.00159 13.002L13.0016 3.00195M3.00159 3.00195L13.0016 13.002"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);

export const chemIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      fill="#1A1A1A"
    />
    <path
      d="M1.14375 9.14351L4.28661 6.00066L7.42996 9.14302L4.28723 12.287L1.14375 9.14351Z"
      fill="#00C2FF"
    />
    <path
      d="M4.85805 5.42922L8.00089 2.28637L11.1438 5.42923L8.0009 8.57208L4.85805 5.42922Z"
      fill="#00C2FF"
    />
    <path
      d="M8.57232 9.14351L11.7152 6.00066L14.8582 9.14351L11.7152 12.2864L8.57232 9.14351Z"
      fill="#00C2FF"
    />
  </svg>
);

export const checkmarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 14.4906C11.5846 14.4906 14.4906 11.5846 14.4906 8C14.4906 6.51551 13.9922 5.14741 13.1536 4.0539C12.7542 3.533 12.2775 3.0744 11.7408 2.69522C10.6835 1.94826 9.393 1.50943 8 1.50943C4.41536 1.50943 1.50943 4.41536 1.50943 8C1.50943 9.393 1.94826 10.6835 2.69522 11.7408C3.0744 12.2775 3.533 12.7542 4.0539 13.1536C5.14741 13.9922 6.51551 14.4906 8 14.4906Z"
      fill="#00F43E"
    />
    <path
      d="M4.73151 7.17231L3.52 8.38385L6.61607 11.48L12.4044 5.69154L11.1929 4.48L6.61607 9.05692L4.73151 7.17231Z"
      fill="#00F43E"
    />
  </svg>
);

export const formationPositions = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 174 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.0762 88.3578L37.2918 68.5281H63.8808M34.0762 88.3578H62.2129M34.0762 88.3578H4.33164M139.924 88.3578L136.44 68.5281H109.851M139.924 88.3578H111.787M139.924 88.3578H169.132M62.2129 88.3578L62.7488 79.2469H110.983L111.787 88.3578M62.2129 88.3578H111.787M14.7923 37.4438H158.895M14.7923 37.4438L24.5164 2.60781M14.7923 37.4438L1.32809 85.6781M158.895 37.4438L148.989 2.71902M158.895 37.4438L172.579 85.4102M48.2785 1L46.1348 12.7906H67.0573M48.2785 1H69.1801M48.2785 1H27.109M125.989 1L127.597 12.7906H106.675M125.989 1H104.82M125.989 1H146.355M69.1801 1L68.6441 6.89531H105.356L104.82 1M69.1801 1H104.82M63.8808 68.5281C67.6513 65.5371 76.5228 63.4367 86.866 63.4367C97.2093 63.4367 106.081 65.5371 109.851 68.5281M63.8808 68.5281H109.851M106.675 12.7906C102.248 15.225 95.025 16.8102 86.866 16.8102C78.707 16.8102 71.484 15.225 67.0573 12.7906M106.675 12.7906H67.0573M24.5164 2.60781L24.9652 1H27.109M24.5164 2.60781C26.0371 2.60781 26.841 2.07188 27.109 1M146.355 1H148.499L148.989 2.71902M146.355 1C146.915 2.11219 147.334 2.636 148.989 2.71902M1.32809 85.6781L0.580078 88.3578H4.33164M1.32809 85.6781C3.25977 85.9461 3.7957 86.75 4.33164 88.3578M169.132 88.3578H173.42L172.579 85.4102M169.132 88.3578C169.668 86.482 170.74 85.6781 172.579 85.4102M111.787 37.9797C111.787 42.2715 100.63 45.7508 86.866 45.7508C73.1025 45.7508 61.9449 42.2715 61.9449 37.9797C61.9449 33.6878 73.1025 30.2086 86.866 30.2086C100.63 30.2086 111.787 33.6878 111.787 37.9797Z"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="0.585856"
    />
  </svg>
);

export const dropdownArrow = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6L5.73258 9.73258C5.88027 9.88027 6.11973 9.88027 6.26742 9.73258L10 6"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const arrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.46967 6.46967C3.76256 6.76256 4.23744 6.76256 4.53033 6.46967L6.71967 4.28033C7.19214 3.80785 6.85752 3 6.18934 3H1.81066C1.14248 3 0.807856 3.80786 1.28033 4.28033L3.46967 6.46967Z"
      fill="currentColor"
    />
  </svg>
);

export const doneIcon = (green) => (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.57313 0.561523C2.04402 0.561523 1.53658 0.780244 1.16245 1.16957C0.788312 1.55889 0.578125 2.08693 0.578125 2.63752V19.2455C0.578125 19.7961 0.788312 20.3241 1.16245 20.7135C1.53658 21.1028 2.04402 21.3215 2.57313 21.3215H14.5431C15.0722 21.3215 15.5797 21.1028 15.9538 20.7135C16.3279 20.3241 16.5381 19.7961 16.5381 19.2455V5.14325C16.538 4.59271 16.3278 4.06476 15.9536 3.67552L13.5456 1.16979C13.1716 0.780439 12.6642 0.561641 12.1352 0.561523H2.57313ZM12.7855 9.68866C12.8808 9.59291 12.9568 9.47837 13.0091 9.35173C13.0613 9.22509 13.0889 9.08888 13.09 8.95105C13.0912 8.81323 13.0659 8.67655 13.0158 8.54898C12.9656 8.42141 12.8916 8.30552 12.7979 8.20806C12.7042 8.1106 12.5929 8.03352 12.4703 7.98133C12.3477 7.92914 12.2163 7.90288 12.0839 7.90407C11.9514 7.90527 11.8205 7.93391 11.6988 7.98831C11.5771 8.04271 11.4671 8.12178 11.3751 8.22092L7.14367 12.6252L5.73221 11.1564C5.54408 10.9673 5.29211 10.8627 5.03057 10.865C4.76902 10.8674 4.51884 10.9766 4.33389 11.169C4.14895 11.3615 4.04404 11.6218 4.04177 11.894C4.0395 12.1662 4.14004 12.4284 4.32174 12.6241L6.36662 14.7531C6.46851 14.8591 6.5895 14.9433 6.72265 15.0007C6.85581 15.0581 6.99854 15.0877 7.14267 15.0877C7.28681 15.0877 7.42953 15.0581 7.56269 15.0007C7.69585 14.9433 7.81683 14.8591 7.91873 14.7531L12.7855 9.68866Z"
      fill={green ? "#00C55E" : "#0094FF"}
    />
    <path
      d="M12.7855 9.68866C12.8808 9.59291 12.9568 9.47837 13.0091 9.35173C13.0613 9.22509 13.0889 9.08888 13.09 8.95105C13.0912 8.81323 13.0659 8.67655 13.0158 8.54898C12.9656 8.42141 12.8916 8.30552 12.7979 8.20806C12.7042 8.1106 12.5929 8.03352 12.4703 7.98133C12.3477 7.92914 12.2163 7.90288 12.0839 7.90407C11.9514 7.90527 11.8205 7.93391 11.6988 7.98831C11.5771 8.04271 11.4671 8.12178 11.3751 8.22092L7.14367 12.6252L5.73221 11.1564C5.54408 10.9673 5.29211 10.8627 5.03057 10.865C4.76902 10.8674 4.51884 10.9766 4.33389 11.169C4.14895 11.3615 4.04404 11.6218 4.04177 11.894C4.0395 12.1662 4.14004 12.4284 4.32174 12.6241L6.36662 14.7531C6.46851 14.8591 6.5895 14.9433 6.72265 15.0007C6.85581 15.0581 6.99854 15.0877 7.14267 15.0877C7.28681 15.0877 7.42953 15.0581 7.56269 15.0007C7.69585 14.9433 7.81683 14.8591 7.91873 14.7531L12.7855 9.68866Z"
      fill="white"
    />
  </svg>
);

export const checkbox = (checked) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <rect
      x="0.5"
      y="0.5"
      width="11"
      height="11"
      rx="1.5"
      fill="#222222"
      stroke="#CDCDCD"
    />
    {checked && (
      <path
        d="M3 6L5 9L9 3"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

export const filter = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M1 1V4L9 12L9 18L15 24L15 12L23 4L23 1H1Z" fill="#343434" />
  </svg>
);

export const filledFilterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M2.08594 1.50195V3.71934L7.90412 9.63239L7.90412 14.0672L12.2678 18.502L12.2678 9.63239L18.0859 3.71934L18.0859 1.50195H2.08594Z"
      fill="currentColor"
    />
  </svg>
);

export const tacticIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M23.5684 32L21.2105 29.6421L23.8632 26.9474L21.2105 24.2947L23.5684 21.8947L26.2632 24.5895L28.9158 21.8947L31.3158 24.2947L28.6211 26.9474L31.3158 29.6421L28.9158 32L26.2632 29.3474L23.5684 32ZM6.05263 28.6316C6.52982 28.6316 6.93011 28.4699 7.25347 28.1465C7.57684 27.8232 7.73797 27.4234 7.73684 26.9474C7.73572 26.4713 7.57404 26.0716 7.25179 25.7482C6.92954 25.4248 6.52982 25.2632 6.05263 25.2632C5.57544 25.2632 5.17572 25.4248 4.85347 25.7482C4.53123 26.0716 4.36954 26.4713 4.36842 26.9474C4.3673 27.4234 4.52898 27.8237 4.85347 28.1482C5.17797 28.4727 5.57768 28.6338 6.05263 28.6316ZM6.05263 32C4.64912 32 3.45614 31.5088 2.47368 30.5263C1.49123 29.5439 1 28.3509 1 26.9474C1 25.5439 1.49123 24.3509 2.47368 23.3684C3.45614 22.386 4.64912 21.8947 6.05263 21.8947C7.09123 21.8947 8.03888 22.1827 8.89558 22.7587C9.75228 23.3347 10.3766 24.1134 10.7684 25.0947C11.8632 24.786 12.7547 24.1825 13.4429 23.2842C14.1312 22.386 14.4748 21.3614 14.4737 20.2105V13.4737C14.4737 11.1439 15.295 9.15818 16.9377 7.51663C18.5804 5.87509 20.566 5.05375 22.8947 5.05263H24.8316L22.1789 2.4L24.5789 0L31.3158 6.73684L24.5789 13.4737L22.1789 11.1158L24.8316 8.42105H22.8947C21.4912 8.42105 20.2982 8.91228 19.3158 9.89474C18.3333 10.8772 17.8421 12.0702 17.8421 13.4737V20.2105C17.8421 22.2596 17.1825 24.0634 15.8632 25.6219C14.5439 27.1803 12.8737 28.1415 10.8526 28.5053C10.5158 29.5439 9.90498 30.386 9.02021 31.0316C8.13544 31.6772 7.14625 32 6.05263 32ZM3.35789 11.7895L1 9.43158L3.65263 6.73684L1 4.08421L3.35789 1.68421L6.05263 4.37895L8.70526 1.68421L11.1053 4.08421L8.41053 6.73684L11.1053 9.43158L8.70526 11.7895L6.05263 9.13684L3.35789 11.7895Z"
      fill="currentColor"
    />
  </svg>
);

export const overviewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M2.66667 0H29.3333C30.0406 0 30.7189 0.280951 31.219 0.781048C31.719 1.28115 32 1.95942 32 2.66667V29.3333C32 30.0406 31.719 30.7189 31.219 31.219C30.7189 31.719 30.0406 32 29.3333 32H2.66667C1.95942 32 1.28115 31.719 0.781048 31.219C0.280951 30.7189 0 30.0406 0 29.3333V2.66667C0 1.95942 0.280951 1.28115 0.781048 0.781048C1.28115 0.280951 1.95942 0 2.66667 0ZM26.6667 6.66667H5.33333C4.97971 6.66667 4.64057 6.80714 4.39052 7.05719C4.14047 7.30724 4 7.64638 4 8C4 8.35362 4.14047 8.69276 4.39052 8.94281C4.64057 9.19286 4.97971 9.33333 5.33333 9.33333H26.6667C27.0203 9.33333 27.3594 9.19286 27.6095 8.94281C27.8595 8.69276 28 8.35362 28 8C28 7.64638 27.8595 7.30724 27.6095 7.05719C27.3594 6.80714 27.0203 6.66667 26.6667 6.66667ZM17.3333 25.3333H26.6667C27.0203 25.3333 27.3594 25.1929 27.6095 24.9428C27.8595 24.6928 28 24.3536 28 24C28 23.6464 27.8595 23.3072 27.6095 23.0572C27.3594 22.8071 27.0203 22.6667 26.6667 22.6667H17.3333C16.9797 22.6667 16.6406 22.8071 16.3905 23.0572C16.1405 23.3072 16 23.6464 16 24C16 24.3536 16.1405 24.6928 16.3905 24.9428C16.6406 25.1929 16.9797 25.3333 17.3333 25.3333ZM14.6667 17.3333H26.6667C27.0203 17.3333 27.3594 17.1929 27.6095 16.9428C27.8595 16.6928 28 16.3536 28 16C28 15.6464 27.8595 15.3072 27.6095 15.0572C27.3594 14.8071 27.0203 14.6667 26.6667 14.6667H14.6667C14.313 14.6667 13.9739 14.8071 13.7239 15.0572C13.4738 15.3072 13.3333 15.6464 13.3333 16C13.3333 16.3536 13.4738 16.6928 13.7239 16.9428C13.9739 17.1929 14.313 17.3333 14.6667 17.3333ZM4 22.6667H6.66667V25.3333C6.66667 25.687 6.80714 26.0261 7.05719 26.2761C7.30724 26.5262 7.64638 26.6667 8 26.6667C8.35362 26.6667 8.69276 26.5262 8.94281 26.2761C9.19286 26.0261 9.33333 25.687 9.33333 25.3333V22.6667H12C12.3536 22.6667 12.6928 22.5262 12.9428 22.2761C13.1929 22.0261 13.3333 21.687 13.3333 21.3333C13.3333 20.9797 13.1929 20.6406 12.9428 20.3905C12.6928 20.1405 12.3536 20 12 20H9.33333V17.3333C9.33333 16.9797 9.19286 16.6406 8.94281 16.3905C8.69276 16.1405 8.35362 16 8 16C7.64638 16 7.30724 16.1405 7.05719 16.3905C6.80714 16.6406 6.66667 16.9797 6.66667 17.3333V20H4C3.64638 20 3.30724 20.1405 3.05719 20.3905C2.80714 20.6406 2.66667 20.9797 2.66667 21.3333C2.66667 21.687 2.80714 22.0261 3.05719 22.2761C3.30724 22.5262 3.64638 22.6667 4 22.6667Z"
      fill="currentColor"
    />
  </svg>
);

export const selectedMobileFrame = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 79 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5546_11623)">
      <path
        d="M0 115.661V127H10.9722L7.68056 123.598H3.29167V119.062L0 115.661Z"
        fill="white"
      />
      <path
        d="M7.68055 3.40179H3.29167V7.9375L0 11.3393V0H10.9722L7.68055 3.40179Z"
        fill="white"
      />
      <path
        d="M75.7083 7.8822V3.40179H71.373L68.0813 0H79V11.284L75.7083 7.8822Z"
        fill="white"
      />
      <path
        d="M71.373 123.598H75.7083V119.118L79 115.716V127H68.0813L71.373 123.598Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5546_11623"
        x="0"
        y="0"
        width="79"
        height="128"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5546_11623"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5546_11623"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const thickArrow = (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.89852 0H0L8.49553 10L0 20H7.89852L16.3941 10L7.89852 0Z"
      fill="white"
    />
  </svg>
);

export const shareIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5969 9.04654H17.3969C17.8743 9.04654 18.3321 9.24105 18.6697 9.58727C19.0072 9.93349 19.1969 10.4031 19.1969 10.8927V19.7542C19.1969 20.2439 19.0072 20.7134 18.6697 21.0597C18.3321 21.4059 17.8743 21.6004 17.3969 21.6004H6.59687C6.11949 21.6004 5.66165 21.4059 5.32408 21.0597C4.98652 20.7134 4.79688 20.2439 4.79688 19.7542V10.8927C4.79688 10.4031 4.98652 9.93349 5.32408 9.58727C5.66165 9.24105 6.11949 9.04654 6.59687 9.04654H8.39687M15.5969 6.0927L11.9969 2.40039M11.9969 2.40039L8.39687 6.0927M11.9969 2.40039V15.0004"
      stroke="currentColor"
      strokeWidth="1.56"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const saveIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4831 2.70919L16.4832 2.70928L18.8912 5.21501L18.8913 5.21509C19.1227 5.45588 19.258 5.78885 19.2581 6.14228C19.2581 6.14233 19.2581 6.14238 19.2581 6.14244V20.2445C19.2581 20.5981 19.1229 20.9312 18.8914 21.172C18.6609 21.4119 18.3551 21.5405 18.0431 21.5405H6.07312C5.76113 21.5405 5.45532 21.4119 5.22485 21.172C4.99337 20.9312 4.85813 20.5981 4.85813 20.2445V3.63655C4.85813 3.28303 4.99337 2.94994 5.22485 2.70906C5.45532 2.46923 5.76113 2.34055 6.07312 2.34055H15.635C15.635 2.34055 15.6351 2.34055 15.6352 2.34055C15.9471 2.34066 16.2528 2.46939 16.4831 2.70919Z"
      stroke="currentColor"
      strokeWidth="1.56"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2907 10.687C16.3859 10.5912 16.4619 10.4767 16.5142 10.35C16.5665 10.2234 16.594 10.0872 16.5952 9.94936C16.5963 9.81154 16.5711 9.67486 16.5209 9.54729C16.4708 9.41972 16.3967 9.30383 16.303 9.20637C16.2094 9.10891 16.098 9.03183 15.9754 8.97964C15.8528 8.92745 15.7215 8.90119 15.589 8.90238C15.4566 8.90358 15.3257 8.93222 15.204 8.98662C15.0823 9.04102 14.9722 9.12009 14.8802 9.21923L10.6488 13.6235L9.23735 12.1547C9.04922 11.9656 8.79725 11.861 8.53571 11.8634C8.27417 11.8657 8.02398 11.9749 7.83904 12.1673C7.65409 12.3598 7.54919 12.6201 7.54691 12.8923C7.54464 13.1645 7.64518 13.4267 7.82688 13.6224L9.87176 15.7514C9.97366 15.8574 10.0946 15.9416 10.2278 15.999C10.361 16.0564 10.5037 16.086 10.6478 16.086C10.792 16.086 10.9347 16.0564 11.0678 15.999C11.201 15.9416 11.322 15.8574 11.4239 15.7514L16.2907 10.687Z"
      fill="currentColor"
    />
  </svg>
);

export const loadIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.80322 13.0671V19.4671C4.80322 20.0329 4.99286 20.5755 5.33043 20.9756C5.668 21.3756 6.12583 21.6004 6.60322 21.6004H17.4032C17.8806 21.6004 18.3384 21.3756 18.676 20.9756C19.0136 20.5755 19.2032 20.0329 19.2032 19.4671V13.0671M8.40322 11.3081L12.0032 15.0004M12.0032 15.0004L15.6032 11.3081M12.0032 15.0004V2.40039"
      stroke="currentColor"
      strokeWidth="1.56"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const binIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83325 17.5C5.37492 17.5 4.9827 17.3369 4.65659 17.0108C4.33047 16.6847 4.16714 16.2922 4.16659 15.8333V5H3.33325V3.33333H7.49992V2.5H12.4999V3.33333H16.6666V5H15.8333V15.8333C15.8333 16.2917 15.6702 16.6842 15.3441 17.0108C15.018 17.3375 14.6255 17.5006 14.1666 17.5H5.83325ZM7.49992 14.1667H9.16658V6.66667H7.49992V14.1667ZM10.8333 14.1667H12.4999V6.66667H10.8333V14.1667Z"
      fill="currentColor"
    />
  </svg>
);
export const subCheckmark = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 12.6176L5.59603 10.0708L9.8816 14.3564L19.7407 4.5L22.2984 7.05795L9.87986 19.5L3 12.6176Z"
      fill="#00C55E"
    />
  </svg>
);

export const subCross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.6003 6.00039L18.0003 2.40039L12.0004 8.40039L6.00038 2.40039L2.40039 6.00039L8.40037 12.0004L2.40039 18.0004L6.00038 21.6004L12.0004 15.6004L18.0003 21.6004L21.6003 18.0004L15.6003 12.0004L21.6003 6.00039Z"
      fill="#F83959"
    />
  </svg>
);
export const rolesPlusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 10 10"
    fill="none"
  >
    <g clipPath="url(#clip0_6192_29155)">
      <path
        d="M10.0039 3.75195V6.25195H6.25391V10.002H3.75391V6.25195H0.00390625V3.75195H3.75391V0.00195312H6.25391V3.75195H10.0039Z"
        fill="#00E46B"
      />
    </g>
    <defs>
      <clipPath id="clip0_6192_29155">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const trending = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="#0094FF" />
    <path
      d="M14.7165 9.33333C14.5248 9.08333 14.2915 8.86667 14.0748 8.65C13.5165 8.15 12.8831 7.79167 12.3498 7.26667C11.1081 6.05 10.8331 4.04167 11.6248 2.5C10.8331 2.69167 10.1415 3.125 9.5498 3.6C7.39146 5.33333 6.54146 8.39167 7.55813 11.0167C7.59146 11.1 7.6248 11.1833 7.6248 11.2917C7.6248 11.475 7.4998 11.6417 7.33313 11.7083C7.14146 11.7917 6.94146 11.7417 6.78313 11.6083C6.73583 11.5687 6.69628 11.5207 6.66646 11.4667C5.7248 10.275 5.5748 8.56667 6.20813 7.2C4.81646 8.33333 4.05813 10.25 4.16646 12.0583C4.21646 12.475 4.26646 12.8917 4.40813 13.3083C4.5248 13.8083 4.7498 14.3083 4.9998 14.75C5.8998 16.1917 7.45813 17.225 9.13313 17.4333C10.9165 17.6583 12.8248 17.3333 14.1915 16.1C15.7165 14.7167 16.2498 12.5 15.4665 10.6L15.3581 10.3833C15.1831 10 14.7165 9.33333 14.7165 9.33333ZM12.0831 14.5833C11.8498 14.7833 11.4665 15 11.1665 15.0833C10.2331 15.4167 9.2998 14.95 8.7498 14.4C9.74146 14.1667 10.3331 13.4333 10.5081 12.6917C10.6498 12.025 10.3831 11.475 10.2748 10.8333C10.1748 10.2167 10.1915 9.69167 10.4165 9.11667C10.5748 9.43333 10.7415 9.75 10.9415 10C11.5831 10.8333 12.5915 11.2 12.8081 12.3333C12.8415 12.45 12.8581 12.5667 12.8581 12.6917C12.8831 13.375 12.5831 14.125 12.0831 14.5833Z"
      fill="white"
    />
  </svg>
);

export const favorite = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.6839 7.68237L10 2.5L8.31614 7.68237H2.86708L7.27547 10.8853L5.59161 16.0676L10 12.8647L14.4084 16.0676L12.7245 10.8853L17.1329 7.68237H11.6839Z"
      fill="currentColor"
    />
  </svg>
);

export const goToAnotherPage = (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.67408 2.25C2.67408 1.83579 3.00987 1.5 3.42408 1.5H11V9.06773C11 9.48194 10.6642 9.81773 10.25 9.81773H9.76764C9.35342 9.81773 9.01764 9.48194 9.01764 9.06773V4.88963L3.93181 9.97045C3.63898 10.263 3.16451 10.263 2.87167 9.97045L2.53111 9.63023C2.23787 9.33728 2.23787 8.862 2.53111 8.56905L7.62476 3.48041H3.42408C3.00987 3.48041 2.67408 3.14463 2.67408 2.73041V2.25Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);

export const exchangeIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.43292 13.0117C3.43292 12.6531 3.72364 12.3623 4.08227 12.3623H9.47365C10.1195 12.3623 10.3694 13.2028 9.82837 13.5556L8.17945 14.631C8.5041 14.7748 8.84519 14.8832 9.197 14.9532C10.1375 15.1402 11.1124 15.0442 11.9983 14.6773C12.8843 14.3103 13.6415 13.6889 14.1743 12.8915C14.6024 12.2508 14.8701 11.5195 14.9588 10.7594C14.9948 10.4507 15.2433 10.1978 15.5541 10.1978H18.2381C18.5489 10.1978 18.8028 10.4501 18.7826 10.7603C18.684 12.2748 18.1887 13.7405 17.3418 15.008C16.3904 16.4318 15.0382 17.5415 13.4562 18.1968C11.8741 18.8521 10.1333 19.0236 8.4538 18.6895C7.38333 18.4766 6.36842 18.0644 5.4596 17.4799L4.62617 18.7578C4.27335 19.2988 3.43292 19.049 3.43292 18.4031V13.0117Z"
      fill="currentColor"
    />
    <path
      d="M17.2857 6.95109C17.2857 7.30972 16.995 7.60045 16.6364 7.60045H11.245C10.5991 7.60045 10.3493 6.76001 10.8903 6.40719L11.9664 5.70536C11.6842 5.59078 11.3904 5.50252 11.0888 5.44253C10.1483 5.25545 9.17338 5.35146 8.28744 5.71843C7.40149 6.0854 6.64426 6.70685 6.1115 7.50418C5.68336 8.14494 5.41564 8.87616 5.32701 9.63633C5.29101 9.94504 5.04243 10.1978 4.73162 10.1978H2.04763C1.73682 10.1978 1.48296 9.9456 1.50314 9.63545C1.60172 8.12087 2.09711 6.65518 2.944 5.38772C3.89535 3.96392 5.24755 2.8542 6.82959 2.19889C8.41164 1.54359 10.1525 1.37213 11.832 1.7062C12.9441 1.92741 13.9962 2.36371 14.9317 2.9848L16.0925 1.20499C16.4453 0.664007 17.2857 0.913844 17.2857 1.55971V6.95109Z"
      fill="currentColor"
    />
  </svg>
);

// FROM HERE =>

// export const untradeable = (
//   <svg
//     width="25"
//     height="25"
//     viewBox="0 0 25 25"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_6825_149975)">
//       <rect
//         x="2"
//         y="1.5"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#FF6100"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_6825_149975)">
//         <path
//           d="M9.43585 11.5542V13.1887L6.85377 10.0684L9.43585 6.94811V8.43396H13.6887L10.4991 11.5542H9.43585Z"
//           fill="white"
//         />
//         <path
//           d="M15.5642 12V10.3656L18.1462 13.4858L15.5642 16.6061V15.1203H11.3113L14.5009 12H15.5642Z"
//           fill="white"
//         />
//         <path
//           fillRule="evenodd"
//           clipRule="evenodd"
//           d="M20.375 12C20.375 16.3492 16.8492 19.875 12.5 19.875C8.15076 19.875 4.625 16.3492 4.625 12C4.625 7.65076 8.15076 4.125 12.5 4.125C16.8492 4.125 20.375 7.65076 20.375 12ZM6.11085 12C6.11085 8.47137 8.97137 5.61085 12.5 5.61085C13.8712 5.61085 15.1416 6.04282 16.1824 6.7781L7.2781 15.6824C6.54282 14.6416 6.11085 13.3712 6.11085 12ZM9.43585 13.1887V11.5542H10.4991L13.6887 8.43396H9.43585V6.94811L6.85377 10.0684L9.43585 13.1887ZM12.5 18.3892C16.0286 18.3892 18.8892 15.5286 18.8892 12C18.8892 10.5387 18.3986 9.19198 17.5731 8.11556L8.61556 17.0731C9.69198 17.8986 11.0387 18.3892 12.5 18.3892ZM15.5642 12V10.3656L18.1462 13.4858L15.5642 16.6061V15.1203H11.3113L14.5009 12H15.5642Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_6825_149975"
//         x="0.95"
//         y="0.975"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_6825_149975"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_6825_149975"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_6825_149975"
//         />
//       </filter>
//       <filter
//         id="filter1_d_6825_149975"
//         x="3.5"
//         y="3.5625"
//         width="18"
//         height="18"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.5625" />
//         <feGaussianBlur stdDeviation="0.5625" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_6825_149975"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_6825_149975"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const transferList = (
//   <svg
//     width="100%"
//     height="100%"
//     viewBox="0 0 24 25"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_2632_46057)">
//       <rect
//         x="1.5"
//         y="1.5"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#8200FF"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_2632_46057)">
//         <path
//           d="M10.4742 15.7722V13.84H6.01231V12.3779L3.57385 14.78L6.01231 17.2343V15.7722H10.4742Z"
//           fill="white"
//         />
//         <path
//           d="M6.94619 18.7652V16.8121H11.408V15.334L13.8465 17.7622L11.408 20.2433V18.7652H6.94619Z"
//           fill="white"
//         />
//         <path
//           fillRule="evenodd"
//           clipRule="evenodd"
//           d="M11.4555 12.8299H6.98331V5.59734C6.98331 5.32611 7.2047 5.1001 7.47037 5.1001H17.3002C17.5659 5.1001 17.7873 5.32611 17.7873 5.59734V16.9434C17.7873 17.2146 17.5598 17.4406 17.2941 17.4406H14.9535L11.4555 14.0052V12.8299ZM8.75446 7.45067V6.41929H12.2967V7.45067H8.75446ZM8.75446 9.61529V8.58391H16.0162V9.61529H8.75446ZM8.75446 11.8072V10.7758H16.0162V11.8072H8.75446ZM13.2266 14.114V13.0827H16.0162V14.114H13.2266Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_2632_46057"
//         x="0.45"
//         y="0.975"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_2632_46057"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_2632_46057"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_2632_46057"
//         />
//       </filter>
//       <filter
//         id="filter1_d_2632_46057"
//         x="1.79994"
//         y="4.21314"
//         width="17.7613"
//         height="18.6909"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.886956" />
//         <feGaussianBlur stdDeviation="0.886956" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_2632_46057"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_2632_46057"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const duplicates = (
//   <svg
//     width="25"
//     height="25"
//     viewBox="0 0 25 25"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_6825_149978)">
//       <rect
//         x="2"
//         y="1.5"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#E42C5D"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_6825_149978)">
//         <path
//           d="M13.2914 12.7908C11.023 13.8053 10.2722 15.0465 10.1902 18.8665H20C19.8968 15.3893 19.3708 13.9041 16.8988 12.7908C16.8988 12.7908 18.0281 11.1805 17.8482 10.0694C17.6161 8.63636 16.5775 7.57039 15.1262 7.5378C13.6387 7.5044 12.5037 8.59852 12.2787 10.0694C12.1073 11.1903 13.2914 12.7908 13.2914 12.7908Z"
//           fill="white"
//         />
//         <path
//           d="M11.8352 12.4105C11.8352 12.4105 10.9921 10.9911 11.2023 9.62599C11.3466 8.68914 11.8626 7.8729 12.5829 7.31321C12.2491 6.06083 11.2658 5.16342 9.93605 5.13356C8.44848 5.10016 7.31353 6.19428 7.08854 7.66512C6.91707 8.78605 8.10116 10.3865 8.10116 10.3865C5.83276 11.401 5.08204 12.6423 5 16.4623H9.2129C9.44228 14.3856 10.0374 13.3756 11.8352 12.4105Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_6825_149978"
//         x="0.95"
//         y="0.975"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_6825_149978"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_6825_149978"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_6825_149978"
//         />
//       </filter>
//       <filter
//         id="filter1_d_6825_149978"
//         x="3.19174"
//         y="4.22868"
//         width="18.6165"
//         height="17.3509"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.904129" />
//         <feGaussianBlur stdDeviation="0.904129" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_6825_149978"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_6825_149978"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const sbcStorage = (
//   <svg
//     width="100%"
//     height="100%"
//     viewBox="0 0 24 25"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_2632_46045)">
//       <rect
//         x="1.5"
//         y="1.5"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#007AFF"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_2632_46045)">
//         <path
//           d="M5.72461 6.46216H18.3246V7.89398H5.72461V6.46216ZM6.5837 8.4667V17.9167H17.4655V8.4667H6.5837ZM14.0292 11.044H9.7337V10.1849H14.0292V11.044Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_2632_46045"
//         x="0.45"
//         y="0.975"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_2632_46045"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_2632_46045"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_2632_46045"
//         />
//       </filter>
//       <filter
//         id="filter1_d_2632_46045"
//         x="3.86511"
//         y="5.53241"
//         width="16.319"
//         height="15.1736"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.929752" />
//         <feGaussianBlur stdDeviation="0.929752" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_2632_46045"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_2632_46045"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const activeSquad = (
//   <svg
//     width="100%"
//     height="100%"
//     viewBox="0 0 24 25"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_2632_46076)">
//       <rect
//         x="1.5"
//         y="1.5"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#22A800"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_2632_46076)">
//         <path
//           d="M10.6708 11.7808C8.83691 12.601 8.22998 13.6044 8.16366 16.6927H16.0944C16.011 13.8816 15.5858 12.6809 13.5873 11.7808C13.5873 11.7808 14.5002 10.4789 14.3548 9.58063C14.1672 8.42212 13.3275 7.56033 12.1542 7.53398C10.9516 7.50698 10.034 8.39152 9.85215 9.58063C9.71352 10.4869 10.6708 11.7808 10.6708 11.7808Z"
//           fill="white"
//         />
//         <path
//           d="M9.80098 11.5988C9.80098 11.5988 9.11939 10.4512 9.28932 9.34761C9.40594 8.59021 9.82312 7.93032 10.4055 7.47784C10.1356 6.46534 9.34064 5.73983 8.26559 5.71569C7.06296 5.68869 6.14541 6.57323 5.96351 7.76234C5.82489 8.66856 6.78217 9.96249 6.78217 9.96249C4.94827 10.7827 4.34135 11.7861 4.27502 14.8745H7.68096C7.86641 13.1955 8.34749 12.379 9.80098 11.5988Z"
//           fill="white"
//         />
//         <path
//           d="M14.4988 11.5991C14.4988 11.5991 15.1804 10.4514 15.0105 9.34778C14.8939 8.59034 14.4767 7.93042 13.8943 7.47792C14.1642 6.46538 14.9592 5.73983 16.0343 5.71569C17.237 5.68868 18.1546 6.57327 18.3365 7.76243C18.4751 8.6687 17.5178 9.96269 17.5178 9.96269C19.3517 10.7829 19.9587 11.7864 20.025 14.8749H16.6189C16.4335 13.1959 15.9524 12.3793 14.4988 11.5991Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_2632_46076"
//         x="0.45"
//         y="0.975"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_2632_46076"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_2632_46076"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_2632_46076"
//         />
//       </filter>
//       <filter
//         id="filter1_d_2632_46076"
//         x="3.2036"
//         y="3.96429"
//         width="17.8929"
//         height="17.1429"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.535714" />
//         <feGaussianBlur stdDeviation="0.535714" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_2632_46076"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_2632_46076"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const manuallyAdded = (
//   <svg
//     width="100%"
//     height="100%"
//     viewBox="0 0 32 33"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_3693_44113)">
//       <rect
//         x="2"
//         y="2"
//         width="28"
//         height="28"
//         rx="5.6"
//         fill="#00A858"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_3693_44113)">
//         <path
//           d="M14.2 7H18.2V14H25.2V18H18.2V25H14.2V18H7.20001V14H14.2V7Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_3693_44113"
//         x="0.6"
//         y="1.3"
//         width="30.8"
//         height="34.3"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.7" />
//         <feGaussianBlur stdDeviation="0.7" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_3693_44113"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_3693_44113"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="5.6" />
//         <feGaussianBlur stdDeviation="8.4" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_3693_44113"
//         />
//       </filter>
//       <filter
//         id="filter1_d_3693_44113"
//         x="4.789"
//         y="5.79449"
//         width="22.822"
//         height="22.822"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="1.20551" />
//         <feGaussianBlur stdDeviation="1.20551" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_3693_44113"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_3693_44113"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// => TO HERE
export const importIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 12.643C14 14.7494 10.866 16.457 7 16.457C3.13401 16.457 0 14.7494 0 12.643C0 11.8194 0.479076 11.0568 1.29367 10.4334C1.70877 10.1157 2.2873 10.2021 2.66561 10.5629C2.79683 10.688 2.78577 10.8986 2.66105 11.0302C2.37938 11.3274 2.22222 11.6584 2.22222 12.0073C2.22222 13.2946 4.36131 14.3381 7 14.3381C9.63869 14.3381 11.7778 13.2946 11.7778 12.0073C11.7778 11.659 11.6211 11.3284 11.3403 11.0316C11.2157 10.8999 11.2047 10.6893 11.3359 10.5643C11.7144 10.2033 12.2933 10.117 12.7084 10.435C13.5218 11.0582 14 11.8202 14 12.643Z"
      fill="#209FF9"
    />
    <path
      d="M10.5999 7.30769L6.9999 11M6.9999 11L3.3999 7.30769M6.9999 11V0.999512"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const importTutorialArrow = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5823 6.64272C11.8752 6.34983 12.3501 6.34983 12.643 6.64272L17.9999 11.9997L12.6488 17.3509C12.3559 17.6438 11.881 17.6438 11.5881 17.3509L11.247 17.0098C10.9541 16.7169 10.9541 16.242 11.247 15.9492L14.2014 12.9948L7.01247 12.9913C6.59854 12.991 6.26304 12.6555 6.26284 12.2416L6.2626 11.7602C6.2624 11.3457 6.59847 11.0097 7.01297 11.0099L14.2129 11.0134L11.2426 8.04308C10.9497 7.75019 10.9497 7.27531 11.2426 6.98242L11.5823 6.64272Z"
      fill="currentColor"
    />
  </svg>
);

export const roundGreenCheckmarkIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8.00049C16 12.4188 12.4183 16.0005 8 16.0005C3.58172 16.0005 0 12.4188 0 8.00049C0 3.58221 3.58172 0.000488281 8 0.000488281C12.4183 0.000488281 16 3.58221 16 8.00049Z"
      fill="#00E46B"
    />
    <path
      d="M3 8.39455L4.36364 7.03087L6.48485 9.15214L11.6364 4.00049L13 5.36416L6.48485 11.8795L3 8.39455Z"
      fill="white"
    />
  </svg>
);

export const roundRedMinusIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.001 8C16.001 12.4183 12.4193 16 8.00098 16C3.5827 16 0.000976562 12.4183 0.000976562 8C0.000976562 3.58172 3.5827 0 8.00098 0C12.4193 0 16.001 3.58172 16.001 8Z"
      fill="#F83959"
    />
    <rect x="2.00146" y="6.5" width="12" height="3" fill="white" />
  </svg>
);

export const minusShield = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 5.32759C19.9617 12.4473 19.7211 16.8119 12 21C4.27891 16.8119 4.03829 12.4473 4 5.32759H4.72158C5.79283 5.32759 6.66124 4.45917 6.66124 3.38793C6.66124 3.38793 9.909 3 12 3C14.091 3 17.3388 3.38793 17.3388 3.38793C17.3388 4.45917 18.2072 5.32759 19.2784 5.32759H20Z"
      fill="#F83959"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0015 12C18.0015 15.3137 15.3152 18 12.0015 18C8.68776 18 6.00146 15.3137 6.00146 12C6.00146 8.68629 8.68776 6 12.0015 6C15.3152 6 18.0015 8.68629 18.0015 12Z"
      fill="#F83959"
    />
    <rect x="7.50098" y="10.875" width="9" height="2.25" fill="white" />
  </svg>
);

export const checkShield = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 5.32759C19.9617 12.4473 19.7211 16.8119 12 21C4.27891 16.8119 4.03829 12.4473 4 5.32759H4.72158C5.79283 5.32759 6.66124 4.45917 6.66124 3.38793C6.66124 3.38793 9.909 3 12 3C14.091 3 17.3388 3.38793 17.3388 3.38793C17.3388 4.45917 18.2072 5.32759 19.2784 5.32759H20Z"
      fill="#00E46B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 12.0007C18 15.3144 15.3137 18.0007 12 18.0007C8.68629 18.0007 6 15.3144 6 12.0007C6 8.68702 8.68629 6.00073 12 6.00073C15.3137 6.00073 18 8.68702 18 12.0007Z"
      fill="#00E46B"
    />
    <path
      d="M8.25 12.2955L9.27273 11.2728L10.8636 12.8637L14.7273 9L15.75 10.0228L10.8636 14.9092L8.25 12.2955Z"
      fill="white"
    />
  </svg>
);

export const CompletedIcon = ({
  fill = "#9CA6B2",
  width = "20",
  height = "20",
}: {
  fill?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.45455 8.78798L3.75 10.4926L8.10606 14.8488L16.25 6.70459L14.5455 5L8.10606 11.4396L5.45455 8.78798Z"
      // fill="#9CA6B2"
      fill={fill}
    />
  </svg>
);

export const FavouriteIcon = ({ fill = "#9CA6B2" }: { fill?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.6839 7.68237L10 2.5L8.31614 7.68237H2.86708L7.27547 10.8853L5.59161 16.0676L10 12.8647L14.4084 16.0676L12.7245 10.8853L17.1329 7.68237H11.6839Z"
      fill={fill}
    />
  </svg>
);

export const HideIcon = ({ fill = "#9CA6B2" }: { fill?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.71592 12.9302C10.0401 14.6371 14.4968 13.5655 16.1423 10.2038C16.2166 10.052 16.2129 9.87192 16.1315 9.72378C15.8447 9.20183 15.4803 8.72679 15.0562 8.30717L12.8996 9.50261C12.9287 9.67001 12.9439 9.84226 12.9439 10.0181C12.9439 11.6513 11.6311 12.9753 10.0116 12.9753C9.24893 12.9753 8.55425 12.6816 8.03268 12.2004L6.71592 12.9302Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.47957 13.6156C9.54657 16.3253 15.2969 14.9715 17.4164 10.3051C17.5263 10.0631 17.5289 9.783 17.4177 9.54167C17.106 8.86507 16.6808 8.24299 16.1688 7.69044L17.9511 6.70249C17.7092 6.11984 17.4051 5.56952 17.0471 5.05979L14.6286 6.40039C11.0553 4.08239 5.5346 4.30794 2.59952 9.63418C2.46909 9.87088 2.46616 10.1648 2.59492 10.4024C2.98842 11.1286 3.44792 11.7656 3.95737 12.3156L2.07476 13.3591C2.32117 13.9397 2.62951 14.4877 2.99151 14.9947L5.47957 13.6156Z"
      fill={fill}
    />
    <path
      d="M3.92796 10.3003C4.2473 10.8377 4.62095 11.3096 5.03579 11.7178L7.12803 10.558C7.096 10.383 7.07926 10.2025 7.07926 10.0181C7.07926 9.73926 7.11753 9.46945 7.18905 9.2137C7.41681 9.36059 7.68749 9.44573 7.97789 9.44573C8.78763 9.44573 9.44406 8.78374 9.44406 7.96713C9.44406 7.67427 9.35963 7.4013 9.21398 7.17162C9.46758 7.09949 9.73513 7.0609 10.0116 7.0609C10.7831 7.0609 11.4851 7.36139 12.0086 7.85266L13.3815 7.09167C10.4364 5.5551 6.31511 5.97247 3.93725 9.74008C3.83051 9.90921 3.82577 10.1283 3.92796 10.3003Z"
      fill={fill}
    />
  </svg>
);

export const closeIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 14L14 2M2 2L14 14"
      stroke="#9CA6B2"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// export const includeObjectivesIcon = (
//   <svg
//     width="28"
//     height="27"
//     viewBox="0 0 25 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_4415_30877)">
//       <rect
//         x="2"
//         y="1"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#8200FF"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_4415_30877)">
//         <path
//           fillRule="evenodd"
//           clipRule="evenodd"
//           d="M12.4999 3.0127L19.8499 7.25622V15.7433L12.4999 19.9868L5.1499 15.7433V7.25622L12.4999 3.0127ZM18.4774 8.06249L12.5239 4.62523L6.57041 8.06249V14.937L12.5239 18.3743L18.4774 14.937V8.06249Z"
//           fill="white"
//         />
//         <path
//           fillRule="evenodd"
//           clipRule="evenodd"
//           d="M12.1766 13.9852L13.4901 9.17591H15.4906C16.3797 9.17591 17.0263 9.82254 17.0263 10.6308C17.0263 11.8231 16.016 12.5303 15.0864 12.5303H13.7864L13.389 13.9852H12.1766ZM14.8641 11.5806H14.0458L14.4431 10.1256H15.2279C15.4704 10.1256 15.8341 10.3883 15.8341 10.7117C15.8341 11.1562 15.43 11.5806 14.8641 11.5806Z"
//           fill="white"
//         />
//         <path
//           d="M8.03409 12.8334L9.06466 12.4899C9.06466 12.4899 9.34757 13.1567 10.0548 13.1567C9.95378 13.1568 10.7621 13.2174 10.7621 12.6313C10.7621 11.8432 8.66052 12.2677 8.66052 10.6712C8.66052 9.23649 10.1154 9.09508 10.5398 9.09508C12.1766 9.09508 12.3584 10.2469 12.3584 10.2469L11.3481 10.5096C11.3481 10.5096 11.146 9.9842 10.5398 9.9842C10.3377 9.9842 9.87295 10.1054 9.87295 10.5096C9.87295 11.2775 11.9745 10.8935 11.9745 12.4091C11.9745 12.5505 11.9543 14.0661 10.0548 14.0661C8.15534 14.0661 8.03409 12.8334 8.03409 12.8334Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_4415_30877"
//         x="0.95"
//         y="0.475"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_4415_30877"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_4415_30877"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_4415_30877"
//         />
//       </filter>
//       <filter
//         id="filter1_d_4415_30877"
//         x="4.0999"
//         y="2.4877"
//         width="16.8002"
//         height="19.0736"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_4415_30877"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_4415_30877"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const includeSbcPlayersIcon = (
//   <svg
//     width="28"
//     height="27"
//     viewBox="0 0 25 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_4415_30881)">
//       <rect
//         x="2"
//         y="1"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#007AFF"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_4415_30881)">
//         <path
//           fillRule="evenodd"
//           clipRule="evenodd"
//           d="M5.94601 14.8309C7.16066 17.2165 9.63946 18.8505 12.4999 18.8505C15.3832 18.8505 17.8788 17.1902 19.0827 14.7735C19.0827 14.7735 18.8163 13.9696 18.4718 13.7399C18.1633 13.5343 15.6917 12.316 15.095 12.022L14.969 11.9598C14.8914 11.921 14.7349 11.6983 14.624 11.5405C14.5875 11.4886 14.5559 11.4436 14.5337 11.4145C14.5236 11.4013 14.5155 11.3914 14.5097 11.3856C14.4522 11.3282 14.3374 11.3282 14.3374 11.3282C14.3374 11.3282 14.2567 11.022 14.28 10.7539C14.3097 10.4122 14.5097 9.77777 14.5097 9.77777C14.5097 9.77777 14.6245 9.83519 14.7968 9.77777C14.969 9.72034 15.3136 8.34221 15.1987 8.22737C15.0839 8.11252 14.969 8.11252 14.969 8.11252C14.969 6.67697 14.9116 5.9879 13.7058 5.24141C13.7058 5.24141 13.5335 4.89688 13.4187 4.89688C13.3747 4.89688 13.2984 4.91382 13.2043 4.93469C13.0524 4.9684 12.8543 5.01235 12.6722 5.01172C12.5789 5.0114 12.5049 4.996 12.4327 4.98094C12.3476 4.96322 12.2648 4.94598 12.1554 4.9543C12.0424 4.96289 11.985 4.99005 11.9168 5.02229C11.8441 5.05671 11.759 5.09692 11.5812 5.12657C11.2366 5.18399 11.0069 5.41368 11.0069 5.41368C10.1765 6.06803 9.98284 6.70152 10.0882 8.16995C10.0882 8.16995 9.90825 8.09531 9.8585 8.16995C9.74365 8.34221 9.91592 9.66292 10.3753 9.83519C10.4134 9.84949 10.4456 9.82843 10.477 9.8079C10.5003 9.79269 10.5231 9.77777 10.5476 9.77777C10.605 9.77777 10.7198 10.6965 10.7198 10.6965V11.3282C10.7198 11.3856 10.2604 11.845 10.0882 11.9598C10.04 11.9919 9.78562 12.1047 9.43395 12.2607C8.52719 12.6627 6.97387 13.3515 6.64287 13.6825C6.1835 14.1419 5.94601 14.8309 5.94601 14.8309ZM10.3753 12.1895C10.3223 12.1013 10.5476 11.7875 10.605 11.7301C10.6624 11.6727 10.605 12.0747 10.605 12.0747C10.605 12.0747 12.3851 13.7973 12.5573 13.7973C12.7296 13.7973 14.5097 12.3618 14.4522 12.0172C14.3948 11.6727 14.4522 11.7301 14.4522 11.7301C14.4743 11.7522 14.4951 11.7725 14.5146 11.7915C14.6472 11.9207 14.717 11.9886 14.6819 12.1321C14.4522 12.7063 13.6589 13.4933 12.7296 14.1993L12.5573 14.3141L12.3276 14.1993L12.2724 14.1618C11.4883 13.6292 11.0937 13.3612 10.3753 12.1895ZM7.61904 16.0368C7.38936 15.9794 6.9874 15.5774 6.9874 15.5774C7.31058 15.4299 7.47137 15.4422 7.79131 15.6923C7.73969 15.3652 7.74208 15.1908 7.90615 14.8883C7.90615 14.8883 8.13584 15.118 8.19326 15.52C8.25068 15.9219 7.84873 16.0942 7.61904 16.0368ZM8.59521 16.4387C8.21015 16.2175 8.02604 16.2391 7.73389 16.3813C7.73389 16.3813 8.13584 16.7833 8.48037 16.7259C8.8249 16.6684 8.93975 16.3813 8.8249 16.0942C8.71006 15.8071 8.48037 15.52 8.48037 15.52C8.31979 15.8445 8.29484 16.0409 8.59521 16.4387ZM9.68623 16.6684C9.57139 16.2665 9.16943 16.0368 9.16943 16.0368L9.16792 16.0504C9.13023 16.3871 9.1086 16.5804 9.45654 16.9555C9.04647 16.7595 8.84727 16.7804 8.53779 17.013C8.53779 17.013 8.93975 17.2427 9.22686 17.2427C9.51397 17.2427 9.80107 17.0704 9.68623 16.6684ZM10.3179 17.3575C9.92417 17.3112 9.75979 17.3882 9.51396 17.6446C9.51396 17.6446 9.8585 17.8743 10.203 17.7595C10.5476 17.6446 10.6624 17.3001 10.4901 16.9555C10.3179 16.611 9.91592 16.5536 9.91592 16.5536C9.93189 16.8999 9.95754 17.0906 10.3179 17.3575ZM11.3515 17.5872C10.9232 17.5695 10.7649 17.6798 10.5476 17.9891C10.5476 17.9891 11.0069 18.104 11.2366 17.9891C11.4663 17.8743 11.5237 17.702 11.5237 17.702C11.8194 17.7652 12.0516 17.8311 12.2577 17.9143C12.0856 18.0012 11.9046 18.1011 11.696 18.2188L11.9257 18.3911C12.1249 18.2351 12.2977 18.1131 12.475 18.0131C12.6915 18.123 12.8924 18.2614 13.1315 18.4485L13.3612 18.2763C13.1019 18.1299 12.8854 18.0112 12.6754 17.9106C12.913 17.8011 13.177 17.7208 13.5335 17.6446C13.5335 17.6446 13.5909 17.8169 13.8206 17.9317C14.0503 18.0466 14.5097 17.9317 14.5097 17.9317C14.2923 17.6224 14.134 17.5121 13.7058 17.5298C14.1034 17.3199 14.2719 17.1756 14.28 16.7833C14.28 16.7833 13.8206 16.8981 13.6483 17.1278C13.4761 17.3575 13.4761 17.4723 13.4761 17.4723C13.068 17.5706 12.7678 17.6749 12.4639 17.8146C12.2021 17.7028 11.9314 17.6141 11.5812 17.5298C11.5812 17.5298 11.5812 17.4149 11.4089 17.1852C11.2366 16.9555 10.7772 16.8407 10.7772 16.8407C10.7854 17.233 10.9538 17.3773 11.3515 17.5872ZM17.4382 15.9794C17.6679 15.9219 18.0698 15.52 18.0698 15.52C17.7467 15.3725 17.5859 15.3848 17.2659 15.6348C17.3175 15.3078 17.3151 15.1334 17.1511 14.8309C17.1511 14.8309 16.9214 15.0606 16.864 15.4626C16.8065 15.8645 17.2085 16.0368 17.4382 15.9794ZM16.462 16.3813C16.8471 16.1601 17.0312 16.1817 17.3233 16.3239C17.3233 16.3239 16.9214 16.7259 16.5769 16.6684C16.2323 16.611 16.1175 16.3239 16.2323 16.0368C16.3472 15.7497 16.5769 15.4626 16.5769 15.4626C16.7374 15.7871 16.7624 15.9835 16.462 16.3813ZM15.371 16.611C15.4858 16.2091 15.8878 15.9794 15.8878 15.9794L15.8893 15.9929C15.927 16.3297 15.9486 16.523 15.6007 16.8981C16.0108 16.7021 16.21 16.723 16.5194 16.9555C16.5194 16.9555 16.1175 17.1852 15.8304 17.1852C15.5433 17.1852 15.2562 17.013 15.371 16.611ZM14.7394 17.3001C15.1331 17.2538 15.2974 17.3308 15.5433 17.5872C15.5433 17.5872 15.1987 17.8169 14.8542 17.702C14.5097 17.5872 14.3948 17.2427 14.5671 16.8981C14.7394 16.5536 15.1413 16.4962 15.1413 16.4962C15.1253 16.8425 15.0997 17.0331 14.7394 17.3001Z"
//           fill="white"
//         />
//         <path
//           d="M18.7015 13.5102C19.1608 13.9696 19.2433 14.429 19.2433 14.429C19.4871 13.8685 19.663 13.2716 19.7607 12.6489C19.7607 12.6489 19.1608 12.4192 18.7015 12.1895C18.6098 12.1437 18.5344 12.0514 18.4603 11.9608L18.4309 11.9248C18.3883 11.8734 18.3454 11.8246 18.2995 11.7875C18.2366 11.7368 18.1272 11.6727 18.1272 11.6727C18.1272 11.6727 18.1178 11.4274 18.1272 11.2707C18.1437 10.9984 18.2421 10.5817 18.2421 10.5817C18.2421 10.5817 18.2995 10.6391 18.4144 10.5817C18.5292 10.5243 18.8737 9.66292 18.8163 9.54808C18.7589 9.43323 18.5866 9.43323 18.5866 9.43323C18.5866 9.43323 18.644 7.88283 18.0698 7.59572C17.7066 7.41411 17.5961 7.27844 17.5349 7.20327C17.4993 7.1596 17.4804 7.13634 17.4382 7.13634C17.4102 7.13634 17.3648 7.1405 17.3074 7.14577C17.1294 7.1621 16.8348 7.18912 16.5769 7.13634C16.5769 7.13634 16.173 7.23565 15.9452 7.36603C15.6559 7.53164 15.3136 7.94026 15.3136 7.94026C15.3136 7.94026 15.5433 8.0551 15.5433 8.51448C15.5433 8.97386 14.969 9.95003 14.969 9.95003C14.969 9.95003 15.0839 10.4094 15.1987 10.5243C15.3136 10.6391 15.4858 10.5817 15.4858 10.5817C15.4858 10.5817 15.5727 10.9592 15.6007 11.2133C15.6156 11.3491 15.6078 11.5112 15.6032 11.6061C15.6018 11.6359 15.6007 11.659 15.6007 11.6727C15.6007 11.7014 15.5433 11.7158 15.4858 11.7301C15.4284 11.7445 15.371 11.7588 15.371 11.7875C15.371 11.8062 15.6745 11.9463 16.1 12.1427C16.9831 12.5502 18.3915 13.2002 18.7015 13.5102Z"
//           fill="white"
//         />
//         <path
//           d="M6.52803 12.1321C6.03429 12.2722 5.75429 12.4155 5.24834 12.7063C5.35119 13.3294 5.53241 13.9261 5.78154 14.4859C5.78154 14.4859 6.06865 13.6251 6.70029 13.2805C7.01611 13.1083 7.73389 12.7494 8.37988 12.4264L8.50029 12.3662C9.09566 12.0684 9.6019 11.8145 9.62881 11.7875C9.68623 11.7301 9.45654 11.6727 9.45654 11.6727C9.45654 11.6727 9.44709 11.4274 9.45654 11.2707C9.47298 10.9984 9.57139 10.5817 9.57139 10.5817C9.57139 10.5817 9.68623 10.6391 9.80107 10.5243C9.91592 10.4094 10.0882 10.0075 10.0308 9.95003C9.97334 9.89261 9.45654 8.97386 9.51396 8.22737C9.51888 8.16345 9.56039 8.12462 9.60142 8.08623C9.64408 8.04633 9.68623 8.0069 9.68623 7.94026C9.68623 7.88018 9.57221 7.80596 9.4327 7.71514C9.30549 7.63233 9.15708 7.53571 9.05459 7.42346C9.02731 7.39357 9.00724 7.36764 8.98964 7.34429L8.98223 7.33443C8.94137 7.27997 8.9109 7.23937 8.8249 7.19377C8.71153 7.13365 8.61605 7.16801 8.51397 7.20474C8.43414 7.23346 8.35028 7.26364 8.25068 7.25119C8.19447 7.24416 8.15078 7.23226 8.10955 7.22102C8.04758 7.20414 7.99118 7.18877 7.90615 7.19377C7.84822 7.19718 7.80618 7.21057 7.7654 7.22356C7.72132 7.23761 7.6787 7.25119 7.61904 7.25119C7.49064 7.25119 7.33193 7.30861 7.33193 7.30861C6.58545 7.76799 6.32947 8.28886 6.47061 9.43323C6.47061 9.43323 6.35576 9.37581 6.29834 9.49065C6.24092 9.6055 6.47061 10.5243 6.58545 10.5817C6.70029 10.6391 6.81514 10.5817 6.81514 10.5817C6.81514 10.5817 6.9099 10.9634 6.92998 11.2133C6.94615 11.4145 6.92998 11.7301 6.92998 11.7301C6.92998 11.7301 6.87256 11.7301 6.75772 11.7875C6.71377 11.8095 6.66983 11.8651 6.63232 11.9254C6.5718 12.0226 6.52803 12.1321 6.52803 12.1321Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_4415_30881"
//         x="0.95"
//         y="0.475"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_4415_30881"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_4415_30881"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_4415_30881"
//         />
//       </filter>
//       <filter
//         id="filter1_d_4415_30881"
//         x="3.50928"
//         y="3.33008"
//         width="17.9814"
//         height="17.9814"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.820312" />
//         <feGaussianBlur stdDeviation="0.820312" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_4415_30881"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_4415_30881"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const ownedIcon = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_7088_145893)">
//       <rect
//         x="1.5"
//         y="1"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#00A858"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_7088_145893)">
//         <path
//           d="M5.5 12.0912L7.27273 10.3184L10.0303 13.0761L16.7273 6.37891L18.5 8.15168L10.0303 16.6216L5.5 12.0912Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_7088_145893"
//         x="0.45"
//         y="0.475"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_7088_145893"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_7088_145893"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_7088_145893"
//         />
//       </filter>
//       <filter
//         id="filter1_d_7088_145893"
//         x="4.375"
//         y="5.81641"
//         width="15.25"
//         height="12.4922"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.5625" />
//         <feGaussianBlur stdDeviation="0.5625" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_7088_145893"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_7088_145893"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const newChemistryIcon = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_7088_145885)">
//       <path
//         d="M1.5 5.2C1.5 2.88041 3.3804 1 5.7 1H18.3C20.6196 1 22.5 2.8804 22.5 5.2V17.8C22.5 20.1196 20.6196 22 18.3 22H5.7C3.38041 22 1.5 20.1196 1.5 17.8V5.2Z"
//         fill="#0576C7"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_7088_145885)">
//         <path
//           d="M16.6484 9.27428L20.3672 12.9937L16.6484 16.7131L12.9297 12.9937L16.6484 9.27428Z"
//           fill="white"
//         />
//         <path
//           d="M7.35156 16.7131L11.0703 12.9937L10.6387 12.562L7.35156 9.27428L3.63281 12.9937L5.56763 14.9289L7.35156 16.7131Z"
//           fill="white"
//         />
//         <path
//           d="M12 12.0639L15.7188 8.34443L13.3148 5.94002L12 4.625L8.28125 8.34443L11.8555 11.9193L12 12.0639Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_7088_145885"
//         x="0.45"
//         y="0.475"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_7088_145885"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_7088_145885"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_7088_145885"
//         />
//       </filter>
//       <filter
//         id="filter1_d_7088_145885"
//         x="2.50781"
//         y="3.0625"
//         width="18.9844"
//         height="18"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.5625" />
//         <feGaussianBlur stdDeviation="0.5625" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_7088_145885"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_7088_145885"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

// export const ratingIcon = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g filter="url(#filter0_di_7088_145878)">
//       <rect
//         x="1.5"
//         y="1"
//         width="21"
//         height="21"
//         rx="4.2"
//         fill="#8200FF"
//         shapeRendering="crispEdges"
//       />
//       <g filter="url(#filter1_d_7088_145878)">
//         <path
//           d="M12 4L13.6839 9.18237H19.1329L14.7245 12.3853L16.4084 17.5676L12 14.3647L7.59161 17.5676L9.27547 12.3853L4.86708 9.18237H10.3161L12 4Z"
//           fill="white"
//         />
//       </g>
//     </g>
//     <defs>
//       <filter
//         id="filter0_di_7088_145878"
//         x="0.45"
//         y="0.475"
//         width="23.1"
//         height="25.725"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.525" />
//         <feGaussianBlur stdDeviation="0.525" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_7088_145878"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_7088_145878"
//           result="shape"
//         />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="4.2" />
//         <feGaussianBlur stdDeviation="6.3" />
//         <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="shape"
//           result="effect2_innerShadow_7088_145878"
//         />
//       </filter>
//       <filter
//         id="filter1_d_7088_145878"
//         x="3.8125"
//         y="3.47266"
//         width="16.375"
//         height="15.6777"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dy="0.527344" />
//         <feGaussianBlur stdDeviation="0.527344" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_7088_145878"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_7088_145878"
//           result="shape"
//         />
//       </filter>
//     </defs>
//   </svg>
// );

export const tradableIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_di_7085_145191)">
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="21"
        rx="4.2"
        fill="#0576C7"
        shapeRendering="crispEdges"
      />
      <g filter="url(#filter1_d_7085_145191)">
        <path
          d="M14.1168 7.70658V11.44H8.70927V14.1778L4.24219 9.57329L8.70927 4.96875V7.70658H14.1168Z"
          fill="white"
        />
        <path
          d="M9.88482 12.56V16.2934H15.2923V19.0312L19.7594 14.4267L15.2923 9.82218V12.56H9.88482Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_7085_145191"
        x="0.45"
        y="0.975"
        width="23.1"
        height="25.725"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.525" />
        <feGaussianBlur stdDeviation="0.525" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7085_145191"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7085_145191"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.2" />
        <feGaussianBlur stdDeviation="6.3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_7085_145191"
        />
      </filter>
      <filter
        id="filter1_d_7085_145191"
        x="3.14309"
        y="3.95045"
        width="17.7158"
        height="17.1982"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.549548" />
        <feGaussianBlur stdDeviation="0.549548" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7085_145191"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7085_145191"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const evolutionCheckMarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4.36364 7.03039L3 8.39406L6.48485 11.879L13 5.36367L11.6364 4L6.48485 9.15165L4.36364 7.03039Z"
      fill="currentColor"
    />
  </svg>
);

export const EvolutionsArrowIcon = ({ className }: { className?: string }) => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    className={className}
  >
    <path
      d="M7.09122 5.7097C7.3724 5.42853 7.3724 4.97265 7.09122 4.69147L4.92946 2.5297C4.47588 2.07613 3.70034 2.39737 3.70034 3.03882L3.70034 7.36235C3.70034 8.0038 4.47588 8.32504 4.92946 7.87147L7.09122 5.7097Z"
      fill="white"
    />
  </svg>
);

export const evolutionsSelectedIcon = (
  <svg
    width="28"
    height="6"
    viewBox="0 0 28 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 1C0.5 0.447715 0.947715 0 1.5 0H11.5C12.0523 0 12.5 0.447715 12.5 1V5C12.5 5.55228 12.0523 6 11.5 6H1.5C0.947715 6 0.5 5.55228 0.5 5V1Z"
      fill="#DAC56B"
    />
    <path d="M12.5 3H15.5" stroke="#DAC56B" />
    <rect x="15.5" width="12" height="6" rx="1" fill="#DAC56B" />
  </svg>
);

export const evolutionsChainedIcon = (
  <svg
    width="58"
    height="6"
    viewBox="0 0 58 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 1C0.5 0.447715 0.947715 0 1.5 0H11.5C12.0523 0 12.5 0.447715 12.5 1V5C12.5 5.55228 12.0523 6 11.5 6H1.5C0.947715 6 0.5 5.55228 0.5 5V1Z"
      fill="#DAC56B"
      fill-opacity="0.3"
    />
    <path d="M12.5 3H15.5" stroke="#DAC56B" strokeOpacity="0.3" />
    <path
      d="M15.5 1C15.5 0.447715 15.9477 0 16.5 0H26.5C27.0523 0 27.5 0.447715 27.5 1V5C27.5 5.55228 27.0523 6 26.5 6H16.5C15.9477 6 15.5 5.55228 15.5 5V1Z"
      fill="#DAC56B"
    />
    <path d="M27.5 3H30.5" stroke="#DAC56B" />
    <rect x="30.5" width="12" height="6" rx="1" fill="#DAC56B" />
    <path d="M42.5 3H45.5" stroke="#DAC56B" strokeOpacity="0.3" />
    <path
      d="M45.5 1C45.5 0.447715 45.9477 0 46.5 0H56.5C57.0523 0 57.5 0.447715 57.5 1V5C57.5 5.55228 57.0523 6 56.5 6H46.5C45.9477 6 45.5 5.55228 45.5 5V1Z"
      fill="#DAC56B"
      fill-opacity="0.3"
    />
  </svg>
);

export const pitchCardPlaceholder = (
  <svg
    viewBox="0 0 111 154"
    preserveAspectRatio="xMidYMid meet"
    className="w-full h-auto"
  >
    <path
      d="M110.512 16.7581V131.404C110.512 138.272 104.597 143.894 97.0554 144.16C79.7592 144.771 64.8599 149.106 55.668 154.007C46.476 149.106 31.5768 144.771 14.2806 144.16C6.73924 143.894 0.824219 138.272 0.824219 131.404V16.7581C10.8829 16.7581 25.8498 -0.0217962 55.668 0.108173C85.4862 -0.0217962 100.453 16.7581 110.512 16.7581Z"
      fill="#8D97A4"
      fillOpacity={0.8}
    />
  </svg>
);

export const gearIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.26368 20L6.86567 16.8C6.65008 16.7167 6.4471 16.6167 6.25672 16.5C6.06634 16.3833 5.8796 16.2583 5.69652 16.125L2.73632 17.375L0 12.625L2.56219 10.675C2.54561 10.5583 2.53731 10.446 2.53731 10.338V9.663C2.53731 9.55433 2.54561 9.44167 2.56219 9.325L0 7.375L2.73632 2.625L5.69652 3.875C5.87894 3.74167 6.06965 3.61667 6.26866 3.5C6.46766 3.38333 6.66667 3.28333 6.86567 3.2L7.26368 0H12.7363L13.1343 3.2C13.3499 3.28333 13.5532 3.38333 13.7443 3.5C13.9353 3.61667 14.1217 3.74167 14.3035 3.875L17.2637 2.625L20 7.375L17.4378 9.325C17.4544 9.44167 17.4627 9.55433 17.4627 9.663V10.337C17.4627 10.4457 17.4461 10.5583 17.4129 10.675L19.9751 12.625L17.2388 17.375L14.3035 16.125C14.1211 16.2583 13.9304 16.3833 13.7313 16.5C13.5323 16.6167 13.3333 16.7167 13.1343 16.8L12.7363 20H7.26368ZM10.0498 13.5C11.0116 13.5 11.8325 13.1583 12.5124 12.475C13.1924 11.7917 13.5323 10.9667 13.5323 10C13.5323 9.03333 13.1924 8.20833 12.5124 7.525C11.8325 6.84167 11.0116 6.5 10.0498 6.5C9.07131 6.5 8.2461 6.84167 7.57413 7.525C6.90216 8.20833 6.5665 9.03333 6.56717 10C6.56783 10.9667 6.90381 11.7917 7.57513 12.475C8.24644 13.1583 9.07131 13.5 10.0498 13.5Z"
      fill="#D4D8DE"
    />
  </svg>
);

export const saveSquadIcon = (
  <svg
    width="17"
    height="26"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.57313 0.560547C2.04402 0.560547 1.53658 0.779268 1.16245 1.16859C0.788312 1.55792 0.578125 2.08596 0.578125 2.63655V19.2445C0.578125 19.7951 0.788312 20.3232 1.16245 20.7125C1.53658 21.1018 2.04402 21.3205 2.57313 21.3205H14.5431C15.0722 21.3205 15.5797 21.1018 15.9538 20.7125C16.3279 20.3232 16.5381 19.7951 16.5381 19.2445V5.14228C16.538 4.59173 16.3278 4.06378 15.9536 3.67455L13.5456 1.16881C13.1716 0.779462 12.6642 0.560664 12.1352 0.560547H2.57313ZM12.7855 9.68768C12.8808 9.59193 12.9568 9.47739 13.0091 9.35075C13.0613 9.22411 13.0889 9.0879 13.09 8.95008C13.0912 8.81225 13.0659 8.67557 13.0158 8.548C12.9656 8.42044 12.8916 8.30454 12.7979 8.20708C12.7042 8.10962 12.5929 8.03255 12.4703 7.98035C12.3477 7.92816 12.2163 7.9019 12.0839 7.9031C11.9514 7.9043 11.8205 7.93293 11.6988 7.98733C11.5771 8.04173 11.4671 8.12081 11.3751 8.21995L7.14367 12.6242L5.73221 11.1554C5.54408 10.9663 5.29211 10.8617 5.03057 10.8641C4.76902 10.8664 4.51884 10.9756 4.33389 11.1681C4.14895 11.3605 4.04404 11.6209 4.04177 11.893C4.0395 12.1652 4.14004 12.4274 4.32174 12.6231L6.36662 14.7521C6.46851 14.8582 6.5895 14.9423 6.72265 14.9997C6.85581 15.0571 6.99854 15.0867 7.14267 15.0867C7.28681 15.0867 7.42953 15.0571 7.56269 14.9997C7.69585 14.9423 7.81683 14.8582 7.91873 14.7521L12.7855 9.68768Z"
      fill="#0094FF"
    />
    <path
      d="M12.7855 9.68768C12.8808 9.59193 12.9568 9.47739 13.0091 9.35075C13.0613 9.22411 13.0889 9.0879 13.09 8.95008C13.0912 8.81225 13.0659 8.67557 13.0158 8.548C12.9656 8.42044 12.8916 8.30454 12.7979 8.20708C12.7042 8.10962 12.5929 8.03255 12.4703 7.98035C12.3477 7.92816 12.2163 7.9019 12.0839 7.9031C11.9514 7.9043 11.8205 7.93293 11.6988 7.98733C11.5771 8.04173 11.4671 8.12081 11.3751 8.21995L7.14367 12.6242L5.73221 11.1554C5.54408 10.9663 5.29211 10.8617 5.03057 10.8641C4.76902 10.8664 4.51884 10.9756 4.33389 11.1681C4.14895 11.3605 4.04404 11.6209 4.04177 11.893C4.0395 12.1652 4.14004 12.4274 4.32174 12.6231L6.36662 14.7521C6.46851 14.8582 6.5895 14.9423 6.72265 14.9997C6.85581 15.0571 6.99854 15.0867 7.14267 15.0867C7.28681 15.0867 7.42953 15.0571 7.56269 14.9997C7.69585 14.9423 7.81683 14.8582 7.91873 14.7521L12.7855 9.68768Z"
      fill="white"
    />
  </svg>
);
